'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = require('prop-types');
var PropTypes__default = _interopDefault(PropTypes);
var ReactDOM = require('react-dom');
var ReactDOM__default = _interopDefault(ReactDOM);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var manorProvider = require('@comparethemarketau/manor-provider');

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/*!
 * Font Awesome Free 5.15.3 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1();
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$1(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var PRODUCTION = function () {
  try {
    return process.env.NODE_ENV === 'production';
  } catch (e) {
    return false;
  }
}();
var DUOTONE_CLASSES = {
  GROUP: 'group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  // For example <script data-search-pseudo-elements src="..."></script>
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray$1(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

var _config = _objectSpread({}, _default, initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;

var config = _objectSpread({}, _config);

WINDOW.FontAwesomeConfig = config;

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

var isNode = typeof global !== 'undefined' && typeof global.process !== 'undefined' && typeof global.process.emit === 'function';
var asyncSetTimer = typeof setImmediate === 'undefined' ? setTimeout : setImmediate;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }

  return abstract;
}

function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}

function makeIconMasking (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      mask = _ref.mask,
      explicitMaskId = _ref.maskId,
      transform = _ref.transform;
  var mainWidth = main.width,
      mainPath = main.icon;
  var maskWidth = mask.width,
      maskPath = mask.icon;
  var trans = transformForSvg({
    transform: transform,
    containerWidth: maskWidth,
    iconWidth: mainWidth
  });
  var maskRect = {
    tag: 'rect',
    attributes: _objectSpread({}, ALL_SPACE, {
      fill: 'white'
    })
  };
  var maskInnerGroupChildrenMixin = mainPath.children ? {
    children: mainPath.children.map(fillBlack)
  } : {};
  var maskInnerGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.inner),
    children: [fillBlack(_objectSpread({
      tag: mainPath.tag,
      attributes: _objectSpread({}, mainPath.attributes, trans.path)
    }, maskInnerGroupChildrenMixin))]
  };
  var maskOuterGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.outer),
    children: [maskInnerGroup]
  };
  var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
  var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
  var maskTag = {
    tag: 'mask',
    attributes: _objectSpread({}, ALL_SPACE, {
      id: maskId,
      maskUnits: 'userSpaceOnUse',
      maskContentUnits: 'userSpaceOnUse'
    }),
    children: [maskRect, maskOuterGroup]
  };
  var defs = {
    tag: 'defs',
    children: [{
      tag: 'clipPath',
      attributes: {
        id: clipId
      },
      children: deGroup(maskPath)
    }, maskTag]
  };
  children.push(defs, {
    tag: 'rect',
    attributes: _objectSpread({
      fill: 'currentColor',
      'clip-path': "url(#".concat(clipId, ")"),
      mask: "url(#".concat(maskId, ")")
    }, ALL_SPACE)
  });
  return {
    children: children,
    attributes: attributes
  };
}

function makeIconStandard (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      transform = _ref.transform,
      styles = _ref.styles;
  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  if (transformIsMeaningful(transform)) {
    var trans = transformForSvg({
      transform: transform,
      containerWidth: main.width,
      iconWidth: main.width
    });
    children.push({
      tag: 'g',
      attributes: _objectSpread({}, trans.outer),
      children: [{
        tag: 'g',
        attributes: _objectSpread({}, trans.inner),
        children: [{
          tag: main.icon.tag,
          children: main.icon.children,
          attributes: _objectSpread({}, main.icon.attributes, trans.path)
        }]
      }]
    });
  } else {
    children.push(main.icon);
  }

  return {
    children: children,
    attributes: attributes
  };
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread({}, styles, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread({}, attributes, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var widthClass = isUploadedIcon ? '' : "fa-w-".concat(Math.ceil(width / height * 16));
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : '', widthClass].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread({}, extra.attributes, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) content.children.push({
    tag: 'title',
    attributes: {
      id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
    },
    children: [title]
  });

  var args = _objectSpread({}, content, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread({}, uploadedIconWidthStyle, extra.styles)
  });

  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalized);
  } else {
    namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var styles = namespace.styles,
    shims = namespace.shims;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    var ligatures = icon[2];
    acc[iconName] = iconName;
    ligatures.forEach(function (ligature) {
      acc[ligature] = iconName;
    });
    return acc;
  });
  var hasRegular = 'far' in styles;
  _byOldName = reduce(shims, function (acc, shim) {
    var oldName = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    acc[oldName] = {
      prefix: prefix,
      iconName: iconName
    };
    return acc;
  }, {});
};
build();

var styles$1 = namespace.styles;
function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };

  if (!transformString) {
    return transform;
  } else {
    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
      var parts = n.toLowerCase().split('-');
      var first = parts[0];
      var rest = parts.slice(1).join('-');

      if (first && rest === 'h') {
        acc.flipX = true;
        return acc;
      }

      if (first && rest === 'v') {
        acc.flipY = true;
        return acc;
      }

      rest = parseFloat(rest);

      if (isNaN(rest)) {
        return acc;
      }

      switch (first) {
        case 'grow':
          acc.size = acc.size + rest;
          break;

        case 'shrink':
          acc.size = acc.size - rest;
          break;

        case 'left':
          acc.x = acc.x - rest;
          break;

        case 'right':
          acc.x = acc.x + rest;
          break;

        case 'up':
          acc.y = acc.y - rest;
          break;

        case 'down':
          acc.y = acc.y + rest;
          break;

        case 'rotate':
          acc.rotate = acc.rotate + rest;
          break;
      }

      return acc;
    }, transform);
  }
};

function MissingIcon(error) {
  this.name = 'MissingIcon';
  this.message = error || 'Icon unavailable';
  this.stack = new Error().stack;
}
MissingIcon.prototype = Object.create(Error.prototype);
MissingIcon.prototype.constructor = MissingIcon;

var FILL = {
  fill: 'currentColor'
};
var ANIMATION_BASE = {
  attributeType: 'XML',
  repeatCount: 'indefinite',
  dur: '2s'
};
var RING = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
  })
};

var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
  attributeName: 'opacity'
});

var DOT = {
  tag: 'circle',
  attributes: _objectSpread({}, FILL, {
    cx: '256',
    cy: '364',
    r: '28'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, ANIMATION_BASE, {
      attributeName: 'r',
      values: '28;14;28;28;14;28;'
    })
  }, {
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;1;1;0;1;'
    })
  }]
};
var QUESTION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '1',
    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;0;0;0;1;'
    })
  }]
};
var EXCLAMATION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '0',
    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '0;0;1;1;0;0;'
    })
  }]
};

var styles$2 = namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray$1(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}

var styles$3 = namespace.styles;

var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}";

function css () {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var Library =
/*#__PURE__*/
function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread({}, _this.definitions[key] || {}, additions[key]);
        defineIcons(key, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        if (!additions[prefix]) additions[prefix] = {};
        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());

    _cssInserted = true;
  }
}

function apiObject(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function findIconDefinition(iconLookup) {
  var _iconLookup$prefix = iconLookup.prefix,
      prefix = _iconLookup$prefix === void 0 ? 'fa' : _iconLookup$prefix,
      iconName = iconLookup.iconName;
  if (!iconName) return;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread({}, params, {
      mask: mask
    }));
  };
}

var library = new Library();
var _cssInserted = false;
var parse = {
  transform: function transform(transformString) {
    return parseTransformString(transformString);
  }
};
var icon = resolveIcons(function (iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return apiObject(_objectSpread({
    type: 'icon'
  }, iconDefinition), function () {
    ensureCss();

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread({}, meaninglessTransform, transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
});

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// Get CSS class list from a props object
function classList(props) {
  var _classes;

  var spin = props.spin,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-spin': spin,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, _defineProperty$1(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty$1(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty$1(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty$1(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties$1(extraProps, ["style"]);

  mixins.attrs['style'] = _objectSpread2({}, mixins.attrs['style'], {}, existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, _objectSpread2({}, mixins.attrs, {}, remaining)].concat(_toConsumableArray(children)));
}

var PRODUCTION$1 = false;

try {
  PRODUCTION$1 = process.env.NODE_ENV === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION$1 && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function normalizeIconArgs(icon) {
  if (parse.icon) {
    return parse.icon(icon);
  } // if the icon is null, there's nothing to do


  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (_typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty$1({}, key, value) : {};
}

function FontAwesomeIcon(_ref) {
  var forwardedRef = _ref.forwardedRef,
      props = _objectWithoutProperties$1(_ref, ["forwardedRef"]);

  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title,
      titleId = props.titleId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? parse.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = icon(iconLookup, _objectSpread2({}, classes, {}, transform, {}, mask, {
    symbol: symbol,
    title: title,
    titleId: titleId
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: forwardedRef
  };
  Object.keys(props).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
}
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  border: PropTypes__default.bool,
  className: PropTypes__default.string,
  mask: PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.array, PropTypes__default.string]),
  fixedWidth: PropTypes__default.bool,
  inverse: PropTypes__default.bool,
  flip: PropTypes__default.oneOf(['horizontal', 'vertical', 'both']),
  icon: PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.array, PropTypes__default.string]),
  listItem: PropTypes__default.bool,
  pull: PropTypes__default.oneOf(['right', 'left']),
  pulse: PropTypes__default.bool,
  rotation: PropTypes__default.oneOf([0, 90, 180, 270]),
  size: PropTypes__default.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: PropTypes__default.bool,
  symbol: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.string]),
  title: PropTypes__default.string,
  transform: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.object]),
  swapOpacity: PropTypes__default.bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  fixedWidth: false,
  inverse: false,
  flip: null,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  symbol: false,
  title: '',
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, React__default.createElement);

/*!
 * Font Awesome Pro 5.15.3 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
var faArrowLeft = {
  prefix: 'far',
  iconName: 'arrow-left',
  icon: [448, 512, [], "f060", "M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"]
};
var faComments = {
  prefix: 'far',
  iconName: 'comments',
  icon: [576, 512, [], "f086", "M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"]
};
var faPhone = {
  prefix: 'far',
  iconName: 'phone',
  icon: [512, 512, [], "f095", "M476.5 22.9L382.3 1.2c-21.6-5-43.6 6.2-52.3 26.6l-43.5 101.5c-8 18.6-2.6 40.6 13.1 53.4l40 32.7C311 267.8 267.8 311 215.4 339.5l-32.7-40c-12.8-15.7-34.8-21.1-53.4-13.1L27.7 329.9c-20.4 8.7-31.5 30.7-26.6 52.3l21.7 94.2c4.8 20.9 23.2 35.5 44.6 35.5C312.3 512 512 313.7 512 67.5c0-21.4-14.6-39.8-35.5-44.6zM69.3 464l-20.9-90.7 98.2-42.1 55.7 68.1c98.8-46.4 150.6-98 197-197l-68.1-55.7 42.1-98.2L464 69.3C463 286.9 286.9 463 69.3 464z"]
};
var faTimes = {
  prefix: 'far',
  iconName: 'times',
  icon: [320, 512, [], "f00d", "M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"]
};

/*!
* tabbable 5.1.6
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var matches = typeof Element === 'undefined' ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

var getCandidates = function getCandidates(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }

  candidates = candidates.filter(filter);
  return candidates;
};

var isContentEditable = function isContentEditable(node) {
  return node.contentEditable === 'true';
};

var getTabindex = function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);

  if (!isNaN(tabindexAttr)) {
    return tabindexAttr;
  } // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.


  if (isContentEditable(node)) {
    return 0;
  } // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.


  if ((node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }

  return node.tabIndex;
};

var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};

var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};

var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};

var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};

var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};

var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }

  var radioScope = node.form || node.ownerDocument;

  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };

  var radioSet;

  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }

  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};

var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};

var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

var isHidden = function isHidden(node) {
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }

  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }

  while (node) {
    if (getComputedStyle(node).display === 'none') {
      return true;
    }

    node = node.parentElement;
  }

  return false;
};

var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node) ||
  /* For a details element with a summary, the summary element gets the focused  */
  isDetailsWithSummary(node)) {
    return false;
  }

  return true;
};

var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(node) {
  if (!isNodeMatchingSelectorFocusable(node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
    return false;
  }

  return true;
};

var tabbable = function tabbable(el, options) {
  options = options || {};
  var regularTabbables = [];
  var orderedTabbables = [];
  var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable);
  candidates.forEach(function (candidate, i) {
    var candidateTabindex = getTabindex(candidate);

    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate
      });
    }
  });
  var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function (a) {
    return a.node;
  }).concat(regularTabbables);
  return tabbableNodes;
};

var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');

var isFocusable = function isFocusable(node) {
  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorFocusable(node);
};

/*!
* focus-trap 6.3.0
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var activeFocusDelay;

var activeFocusTraps = function () {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];

        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();

var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};

var isEscapeEvent = function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};

var isTabEvent = function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};

var delay = function delay(fn) {
  return setTimeout(fn, 0);
}; // Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs


var findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }

    return true; // next
  });
  return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */


var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return typeof value === 'function' ? value.apply(void 0, params) : value;
};

var createFocusTrap = function createFocusTrap(elements, userOptions) {
  var doc = document;

  var config = _objectSpread2$1({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);

  var state = {
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying the first and last tabbable nodes in all containers/groups in
    //  the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{ container: HTMLElement, firstTabbableNode: HTMLElement|null, lastTabbableNode: HTMLElement|null }>}
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  var containersContain = function containersContain(element) {
    return state.containers.some(function (container) {
      return container.contains(element);
    });
  };

  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];

    if (!optionValue) {
      return null;
    }

    var node = optionValue;

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue);

      if (!node) {
        throw new Error("`".concat(optionName, "` refers to no known node"));
      }
    }

    if (typeof optionValue === 'function') {
      node = optionValue();

      if (!node) {
        throw new Error("`".concat(optionName, "` did not return a node"));
      }
    }

    return node;
  };

  var getInitialFocusNode = function getInitialFocusNode() {
    var node;

    if (getNodeForOption('initialFocus') !== null) {
      node = getNodeForOption('initialFocus');
    } else if (containersContain(doc.activeElement)) {
      node = doc.activeElement;
    } else {
      var firstTabbableGroup = state.tabbableGroups[0];
      var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
      node = firstTabbableNode || getNodeForOption('fallbackFocus');
    }

    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }

    return node;
  };

  var updateTabbableNodes = function updateTabbableNodes() {
    state.tabbableGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container);

      if (tabbableNodes.length > 0) {
        return {
          container: container,
          firstTabbableNode: tabbableNodes[0],
          lastTabbableNode: tabbableNodes[tabbableNodes.length - 1]
        };
      }

      return undefined;
    }).filter(function (group) {
      return !!group;
    }); // remove groups with no tabbable nodes
    // throw if no groups have tabbable nodes and we don't have a fallback focus node either

    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus')) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }
  };

  var tryFocus = function tryFocus(node) {
    if (node === doc.activeElement) {
      return;
    }

    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;

    if (isSelectableInput(node)) {
      node.select();
    }
  };

  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus');
    return node ? node : previousActiveElement;
  }; // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.


  var checkPointerDown = function checkPointerDown(e) {
    if (containersContain(e.target)) {
      // allow the click since it ocurred inside the trap
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(e.target)
      });
      return;
    } // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)


    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    } // otherwise, prevent the click


    e.preventDefault();
  }; // In case focus escapes the trap for some strange reason, pull it back in.


  var checkFocusIn = function checkFocusIn(e) {
    var targetContained = containersContain(e.target); // In Firefox when you Tab out of an iframe the Document is briefly focused.

    if (targetContained || e.target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = e.target;
      }
    } else {
      // escaped! pull it back in to where it just left
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  }; // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.


  var checkTab = function checkTab(e) {
    updateTabbableNodes();
    var destinationNode = null;

    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      var containerIndex = findIndex(state.tabbableGroups, function (_ref) {
        var container = _ref.container;
        return container.contains(e.target);
      });

      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back in to...
        if (e.shiftKey) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        // REVERSE
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return e.target === firstTabbableNode;
        });

        if (startOfGroupIndex >= 0) {
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        // FORWARD
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return e.target === lastTabbableNode;
        });

        if (lastOfGroupIndex >= 0) {
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      destinationNode = getNodeForOption('fallbackFocus');
    }

    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    }
  };

  var checkKey = function checkKey(e) {
    if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
      e.preventDefault();
      trap.deactivate();
      return;
    }

    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };

  var checkClick = function checkClick(e) {
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }

    if (containersContain(e.target)) {
      return;
    }

    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  }; //
  // EVENT LISTENERS
  //


  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    } // There can be only one listening focus trap at a time


    activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.

    activeFocusDelay = config.delayInitialFocus ? delay(function () {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };

  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  }; //
  // TRAP DEFINITION
  //


  trap = {
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }

      updateTabbableNodes();
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      var onActivate = activateOptions && activateOptions.onActivate ? activateOptions.onActivate : config.onActivate;

      if (onActivate) {
        onActivate();
      }

      addListeners();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }

      clearTimeout(activeFocusDelay);
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate;

      if (onDeactivate) {
        onDeactivate();
      }

      var returnFocus = deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate;

      if (returnFocus) {
        delay(function () {
          tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
        });
      }

      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }

      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }

      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });

      if (state.active) {
        updateTabbableNodes();
      }

      return this;
    }
  }; // initialize container elements

  trap.updateContainerElements(elements);
  return trap;
};

var focusTrap_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createFocusTrap: createFocusTrap
});

function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof$1(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }







var createFocusTrap$1 = focusTrap_esm.createFocusTrap; // TODO: These issues are related to older React features which we'll likely need
//  to fix in order to move the code forward to the next major version of React.
//  @see https://github.com/davidtheclark/focus-trap-react/issues/77

/* eslint-disable react/no-find-dom-node */


var FocusTrap = /*#__PURE__*/function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  var _super = _createSuper(FocusTrap);

  function FocusTrap(props) {
    var _this;

    _classCallCheck$1(this, FocusTrap);

    _this = _super.call(this, props); // We need to hijack the returnFocusOnDeactivate option,
    // because React can move focus into the element before we arrived at
    // this lifecycle hook (e.g. with autoFocus inputs). So the component
    // captures the previouslyFocusedElement in componentWillMount,
    // then (optionally) returns focus to it in componentWillUnmount.

    _this.tailoredFocusTrapOptions = {
      returnFocusOnDeactivate: false
    }; // because of the above, we maintain our own flag for this option, and
    //  default it to `true` because that's focus-trap's default

    _this.returnFocusOnDeactivate = true;
    var focusTrapOptions = props.focusTrapOptions;

    for (var optionName in focusTrapOptions) {
      if (!Object.prototype.hasOwnProperty.call(focusTrapOptions, optionName)) {
        continue;
      }

      if (optionName === 'returnFocusOnDeactivate') {
        _this.returnFocusOnDeactivate = !!focusTrapOptions[optionName];
        continue;
      }

      _this.tailoredFocusTrapOptions[optionName] = focusTrapOptions[optionName];
    } // elements from which to create the focus trap on mount; if a child is used
    //  instead of the `containerElements` prop, we'll get the child's related
    //  element when the trap renders and then is declared 'mounted'


    _this.focusTrapElements = props.containerElements || []; // now we remember what the currently focused element is, not relying on focus-trap

    _this.updatePreviousElement();

    return _this;
  }
  /** Update the previously focused element with the currently focused element. */


  _createClass$1(FocusTrap, [{
    key: "updatePreviousElement",
    value: function updatePreviousElement() {
      if (typeof document !== 'undefined') {
        this.previouslyFocusedElement = document.activeElement;
      }
    }
    /** Returns focus to the element that had focus when the trap was activated. */

  }, {
    key: "returnFocus",
    value: function returnFocus() {
      if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
        this.previouslyFocusedElement.focus();
      }
    }
  }, {
    key: "setupFocusTrap",
    value: function setupFocusTrap() {
      if (!this.focusTrap) {
        var focusTrapElementDOMNodes = this.focusTrapElements.map( // NOTE: `findDOMNode()` does not support CSS selectors; it'll just return
        //  a new text node with the text wrapped in it instead of treating the
        //  string as a selector and resolving it to a node in the DOM
        ReactDOM__default.findDOMNode);
        var nodesExist = focusTrapElementDOMNodes.some(Boolean);

        if (nodesExist) {
          // eslint-disable-next-line react/prop-types -- _createFocusTrap is an internal prop
          this.focusTrap = this.props._createFocusTrap(focusTrapElementDOMNodes, this.tailoredFocusTrapOptions);

          if (this.props.active) {
            this.focusTrap.activate();
          }

          if (this.props.paused) {
            this.focusTrap.pause();
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupFocusTrap();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.focusTrap) {
        if (prevProps.containerElements !== this.props.containerElements) {
          this.focusTrap.updateContainerElements(this.props.containerElements);
        }

        if (prevProps.active && !this.props.active) {
          // NOTE: we never let the trap return the focus since we do that ourselves
          this.focusTrap.deactivate({
            returnFocus: false
          });

          if (this.returnFocusOnDeactivate) {
            this.returnFocus();
          }

          return; // un/pause does nothing on an inactive trap
        }

        if (!prevProps.active && this.props.active) {
          this.updatePreviousElement();
          this.focusTrap.activate();
        }

        if (prevProps.paused && !this.props.paused) {
          this.focusTrap.unpause();
        } else if (!prevProps.paused && this.props.paused) {
          this.focusTrap.pause();
        }
      } else if (prevProps.containerElements !== this.props.containerElements) {
        this.focusTrapElements = this.props.containerElements;
        this.setupFocusTrap();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.focusTrap) {
        // NOTE: we never let the trap return the focus since we do that ourselves
        this.focusTrap.deactivate({
          returnFocus: false
        });
      }

      if (this.returnFocusOnDeactivate) {
        this.returnFocus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var child = this.props.children ? React__default.Children.only(this.props.children) : undefined;

      if (child) {
        if (child.type && child.type === React__default.Fragment) {
          throw new Error('A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.');
        }

        var composedRefCallback = function composedRefCallback(element) {
          var containerElements = _this2.props.containerElements;

          if (child) {
            if (typeof child.ref === 'function') {
              child.ref(element);
            } else if (child.ref) {
              child.ref.current = element;
            }
          }

          _this2.focusTrapElements = containerElements ? containerElements : [element];
        };

        var childWithRef = React__default.cloneElement(child, {
          ref: composedRefCallback
        });
        return childWithRef;
      }

      return null;
    }
  }]);

  return FocusTrap;
}(React__default.Component); // support server-side rendering where `Element` will not be defined


var ElementType = typeof Element === 'undefined' ? Function : Element;
FocusTrap.propTypes = {
  active: PropTypes__default.bool,
  paused: PropTypes__default.bool,
  focusTrapOptions: PropTypes__default.shape({
    onActivate: PropTypes__default.func,
    onDeactivate: PropTypes__default.func,
    initialFocus: PropTypes__default.oneOfType([PropTypes__default.instanceOf(ElementType), PropTypes__default.string, PropTypes__default.func]),
    fallbackFocus: PropTypes__default.oneOfType([PropTypes__default.instanceOf(ElementType), PropTypes__default.string, PropTypes__default.func]),
    escapeDeactivates: PropTypes__default.bool,
    clickOutsideDeactivates: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.func]),
    returnFocusOnDeactivate: PropTypes__default.bool,
    setReturnFocus: PropTypes__default.oneOfType([PropTypes__default.instanceOf(ElementType), PropTypes__default.string, PropTypes__default.func]),
    allowOutsideClick: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.func]),
    preventScroll: PropTypes__default.bool
  }),
  containerElements: PropTypes__default.arrayOf(PropTypes__default.instanceOf(ElementType)),
  children: PropTypes__default.oneOfType([PropTypes__default.element, // React element
  PropTypes__default.instanceOf(ElementType) // DOM element
  ]) // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
  //  specify it here. It's expected to be set to the function returned from
  //  require('focus-trap'), or one with a compatible interface.

};
FocusTrap.defaultProps = {
  active: true,
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap$1
};
var focusTrapReact = FocusTrap;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = __assign$1({ async: true, ssr: false }, options);
    return medium;
}

var SideCar = function (_a) {
    var sideCar = _a.sideCar, rest = __rest$1(_a, ["sideCar"]);
    if (!sideCar) {
        throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    }
    var Target = sideCar.read();
    if (!Target) {
        throw new Error('Sidecar medium not found');
    }
    return React.createElement(Target, __assign$1({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

var effectCar = createSidecarMedium();

/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = React.useState(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            }
        }
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    return useCallbackRef(defaultValue, function (newValue) {
        return refs.forEach(function (ref) { return assignRef(ref, newValue); });
    });
}

var nothing = function () {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */
var RemoveScroll = React.forwardRef(function (props, parentRef) {
    var ref = React.useRef(null);
    var _a = React.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
    var SideCar = sideCar;
    var containerRef = useMergeRefs([
        ref,
        parentRef
    ]);
    var containerProps = __assign({}, rest, callbacks);
    return (React.createElement(React.Fragment, null,
        enabled && (React.createElement(SideCar, { sideCar: effectCar, removeScrollBar: removeScrollBar, shards: shards, noIsolation: noIsolation, inert: inert, setCallbacks: setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref })),
        forwardProps ? (React.cloneElement(React.Children.only(children), __assign({}, containerProps, { ref: containerRef }))) : (React.createElement(Container, __assign({}, containerProps, { className: className, ref: containerRef }), children))));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
RemoveScroll.classNames = {
    fullWidth: fullWidthClassName,
    zeroRight: zeroRightClassName
};

var getNonce = function () {
    if (typeof __webpack_nonce__ !== 'undefined') {
        return __webpack_nonce__;
    }
    return undefined;
};

function makeStyleTag() {
    if (!document)
        return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = getNonce();
    if (nonce) {
        tag.setAttribute('nonce', nonce);
    }
    return tag;
}
function injectStyles(tag, css) {
    if (tag.styleSheet) {
        tag.styleSheet.cssText = css;
    }
    else {
        tag.appendChild(document.createTextNode(css));
    }
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function () {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function (style) {
            if (counter == 0) {
                if (stylesheet = makeStyleTag()) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function () {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles) {
        React.useEffect(function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, []);
    };
};

var styleSingleton = function () {
    var useStyle = styleHookSingleton();
    var Sheet = function (_a) {
        var styles = _a.styles;
        useStyle(styles);
        return null;
    };
    return Sheet;
};

var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0,
};
var parse$1 = function (x) { return parseInt(x || '', 10) || 0; };
var getOffset = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        parse$1(left),
        parse$1(top),
        parse$1(right),
    ];
};
var getGapWidth = function (gapMode) {
    if (gapMode === void 0) { gapMode = 'margin'; }
    if (typeof window === 'undefined') {
        return zeroGap;
    }
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
    };
};

var Style = styleSingleton();
var getStyles = function (_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) { gapMode = 'margin'; }
    return "\n  ." + noScrollbarsClassName + " {\n   overflow: hidden " + important + ";\n   padding-right: " + gap + "px " + important + ";\n  }\n  body {\n    overflow: hidden " + important + ";\n    " + [
        allowRelative && "position: relative " + important + ";",
        gapMode === 'margin' && "\n    padding-left: " + left + "px;\n    padding-top: " + top + "px;\n    padding-right: " + right + "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: " + gap + "px " + important + ";\n    ",
        gapMode === 'padding' && "padding-right: " + gap + "px " + important + ";",
    ].filter(Boolean).join('') + "\n  }\n  \n  ." + zeroRightClassName + " {\n    right: " + gap + "px " + important + ";\n  }\n  \n  ." + fullWidthClassName + " {\n    margin-right: " + gap + "px " + important + ";\n  }\n  \n  ." + zeroRightClassName + " ." + zeroRightClassName + " {\n    right: 0 " + important + ";\n  }\n  \n  ." + fullWidthClassName + " ." + fullWidthClassName + " {\n    margin-right: 0 " + important + ";\n  }\n  \n  body {\n    " + removedBarSizeVariable + ": " + gap + "px;\n  }\n";
};
var RemoveScrollBar = function (props) {
    var _a = React.useState(getGapWidth(props.gapMode)), gap = _a[0], setGap = _a[1];
    React.useEffect(function () {
        setGap(getGapWidth(props.gapMode));
    }, [props.gapMode]);
    var noRelative = props.noRelative, noImportant = props.noImportant, _b = props.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    return React.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : '') });
};

var elementCouldBeVScrolled = function (node) {
    var styles = window.getComputedStyle(node);
    return (styles.overflowY !== 'hidden' && // not-not-scrollable
        !(styles.overflowY === styles.overflowX && styles.overflowY === 'visible') // scrollable
    );
};
var elementCouldBeHScrolled = function (node) {
    var styles = window.getComputedStyle(node);
    // we allow horizontal scroll on range elements
    if (node.type === "range") {
        return true;
    }
    return (styles.overflowX !== 'hidden' && // not-not-scrollable
        !(styles.overflowY === styles.overflowX && styles.overflowX === 'visible') // scrollable
    );
};
var locationCouldBeScrolled = function (axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
            current = current.host;
        }
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) {
                return true;
            }
        }
        current = current.parentNode;
    } while (current && current !== document.body);
    return false;
};
var getVScrollVariables = function (_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [scrollTop, scrollHeight, clientHeight];
};
var getHScrollVariables = function (_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [scrollLeft, scrollWidth, clientWidth];
};
var elementCouldBeScrolled = function (axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) { return (
/**
 * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
 * and then increasingly negative as you scroll towards the end of the content.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
 */
axis === 'h' && direction === 'rtl' ? -1 : 1); };
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    } while (
    // portaled content
    (!targetInLock && target !== document.body) ||
        // self content
        (targetInLock && (endTarget.contains(target) || endTarget === target)));
    if (isDeltaPositive &&
        ((noOverscroll && availableScroll === 0) ||
            (!noOverscroll && delta > availableScroll))) {
        shouldCancelScroll = true;
    }
    else if (!isDeltaPositive &&
        ((noOverscroll && availableScrollTop === 0) ||
            (!noOverscroll && -delta > availableScrollTop))) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            }
        });
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, options);
    }
    catch (err) {
        passiveSupported = false;
    }
}
var nonPassive = passiveSupported ? { passive: false } : false;

var getTouchXY = function (event) {
    return 'changedTouches' in event
        ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY]
        : [0, 0];
};
var getDeltaXY = function (event) { return [event.deltaX, event.deltaY]; };
var extractRef = function (ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function (id) { return "\n  .block-interactivity-" + id + " {pointer-events: none;}\n  .allow-interactivity-" + id + " {pointer-events: all;}\n"; };
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = React.useRef([]);
    var touchStartRef = React.useRef([0, 0]);
    var activeAxis = React.useRef();
    var id = React.useState(idCounter++)[0];
    var Style = React.useState(function () { return styleSingleton(); })[0];
    var lastProps = React.useRef(props);
    React.useEffect(function () {
        lastProps.current = props;
    }, [props]);
    React.useEffect(function () {
        if (props.inert) {
            document.body.classList.add("block-interactivity-" + id);
            var allow_1 = [
                props.lockRef.current
            ].concat((props.shards || []).map(extractRef)).filter(Boolean);
            allow_1.forEach(function (el) { return el.classList.add("allow-interactivity-" + id); });
            return function () {
                document.body.classList.remove("block-interactivity-" + id);
                allow_1.forEach(function (el) {
                    return el.classList.remove("allow-interactivity-" + id);
                });
            };
        }
        return;
    }, [props.inert, props.lockRef.current, props.shards]);
    var shouldCancelEvent = React.useCallback(function (event, parent) {
        if ('touches' in event && event.touches.length === 2) {
            return !lastProps.current.allowPinchZoom;
        }
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
        if (!canBeScrolledInMainDirection) {
            return true;
        }
        if (canBeScrolledInMainDirection) {
            currentAxis = moveDirection;
        }
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
            // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) {
            return false;
        }
        if (!activeAxis.current &&
            'changedTouches' in event &&
            (deltaX || deltaY)) {
            activeAxis.current = currentAxis;
        }
        if (!currentAxis) {
            return true;
        }
        var cancelingAxis = activeAxis.current || currentAxis;
        return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = React.useCallback(function (_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
            // not the last active
            return;
        }
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function (e) {
            return e.name === event.type &&
                e.target === event.target &&
                deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || [])
                .map(extractRef)
                .filter(Boolean)
                .filter(function (node) { return node.contains(event.target); });
            var shouldStop = shardNodes.length > 0
                ? shouldCancelEvent(event, shardNodes[0])
                : !lastProps.current.noIsolation;
            if (shouldStop) {
                event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = React.useCallback(function (name, delta, target, should) {
        var event = { name: name, delta: delta, target: target, should: should };
        shouldPreventQueue.current.push(event);
        setTimeout(function () {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) { return e !== event; });
        }, 1);
    }, []);
    var scrollTouchStart = React.useCallback(function (event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = React.useCallback(function (event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = React.useCallback(function (event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    React.useEffect(function () {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, nonPassive);
        document.addEventListener('touchmove', shouldPrevent, nonPassive);
        document.addEventListener('touchstart', scrollTouchStart, nonPassive);
        return function () {
            lockStack = lockStack.filter(function (inst) { return inst !== Style; });
            document.removeEventListener('wheel', shouldPrevent, nonPassive);
            document.removeEventListener('touchmove', shouldPrevent, nonPassive);
            document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return (React.createElement(React.Fragment, null,
        inert ? React.createElement(Style, { styles: generateStyle(id) }) : null,
        removeScrollBar ? React.createElement(RemoveScrollBar, { gapMode: "margin" }) : null));
}

var SideCar$1 = exportSidecar(effectCar, RemoveScrollSideCar);

var ReactRemoveScroll = React.forwardRef(function (props, ref) { return (React.createElement(RemoveScroll, __assign({}, props, { ref: ref, sideCar: SideCar$1 }))); });
ReactRemoveScroll.classNames = RemoveScroll.classNames;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_isinteger = isInteger;

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty$3(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    @media ", " {\n      ", "\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var THEME_CONF = 'flexboxgrid';
var BASE_CONF = {
  gridSize: 12,
  gutterWidth: 1,
  outerMargin: 2,
  mediaQuery: 'only screen',
  container: {
    sm: 46,
    md: 61,
    lg: 76
  },
  breakpoints: {
    xs: 0,
    sm: 48,
    md: 64,
    lg: 75
  }
};
var configCache = [];

var makeCacheId = function makeCacheId(props) {
  return JSON.stringify(props.theme && props.theme[THEME_CONF] || {});
};

var resolveConfig = function resolveConfig(props) {
  var themeConf = props.theme && props.theme[THEME_CONF] || {};

  var conf = _objectSpread2$2({}, BASE_CONF, {}, themeConf, {
    container: _objectSpread2$2({}, BASE_CONF.container, {}, themeConf.container),
    breakpoints: _objectSpread2$2({}, BASE_CONF.breakpoints, {}, themeConf.breakpoints)
  });

  conf.media = Object.keys(conf.breakpoints).reduce(function (media, breakpoint) {
    var breakpointWidth = conf.breakpoints[breakpoint];
    media[breakpoint] = makeMedia([conf.mediaQuery, breakpoint !== 0 && "(min-width: " + breakpointWidth + "em)"].filter(Boolean).join(' and '));
    return media;
  }, {});
  return conf;
};

var DIMENSION_NAMES = ['xs', 'sm', 'md', 'lg'];
function config$1(props) {
  var cacheId = makeCacheId(props);

  if (configCache[0] === cacheId) {
    return configCache[1];
  }

  var conf = resolveConfig(props);
  configCache[0] = cacheId;
  configCache[1] = conf;
  return conf;
}

function makeMedia(media) {
  return function () {
    return styled.css(_templateObject(), media, styled.css.apply(void 0, arguments));
  };
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n        width: ", "rem;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: ", ";\n  padding-left: ", ";\n\n  ", "\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var Grid = styled__default.div(_templateObject$1(), function (p) {
  return config$1(p).outerMargin + 'rem';
}, function (p) {
  return config$1(p).outerMargin + 'rem';
}, function (p) {
  return !p.fluid && styled.css(_templateObject2(), DIMENSION_NAMES.map(function (t) {
    return config$1(p).container[t] && config$1(p).media[t](_templateObject3(), function (p) {
      return config$1(p).container[t];
    });
  }));
});
Grid.displayName = 'Grid';
Grid.propTypes = {
  fluid: PropTypes__default.bool,
  children: PropTypes__default.node
};

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n    order: 1;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n    order: -1;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n    justify-content: space-between;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n    justify-content: space-around;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n    align-items: flex-end;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n    align-items: center;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n    align-items: flex-start;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n    justify-content: flex-end;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n    justify-content: center;\n  "]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n    justify-content: flex-start;\n  "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 1 auto;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-right: ", "rem;\n  margin-left: ", "rem;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var ModificatorType = PropTypes__default.oneOf(DIMENSION_NAMES);
var Row = styled__default.div(_templateObject$2(), function (p) {
  return config$1(p).gutterWidth / 2 * -1;
}, function (p) {
  return config$1(p).gutterWidth / 2 * -1;
}, function (p) {
  return p.reverse && "\n    flex-direction: row-reverse;\n  ";
}, function (p) {
  return p.start && config$1(p).media[p.start](_templateObject2$1());
}, function (p) {
  return p.center && config$1(p).media[p.center](_templateObject3$1());
}, function (p) {
  return p.end && config$1(p).media[p.end](_templateObject4());
}, function (p) {
  return p.top && config$1(p).media[p.top](_templateObject5());
}, function (p) {
  return p.middle && config$1(p).media[p.middle](_templateObject6());
}, function (p) {
  return p.bottom && config$1(p).media[p.bottom](_templateObject7());
}, function (p) {
  return p.around && config$1(p).media[p.around](_templateObject8());
}, function (p) {
  return p.between && config$1(p).media[p.between](_templateObject9());
}, function (p) {
  return p.first && config$1(p).media[p.first](_templateObject10());
}, function (p) {
  return p.last && config$1(p).media[p.last](_templateObject11());
});
Row.displayName = 'Row';
Row.propTypes = {
  reverse: PropTypes__default.bool,
  start: ModificatorType,
  center: ModificatorType,
  end: ModificatorType,
  top: ModificatorType,
  middle: ModificatorType,
  bottom: ModificatorType,
  around: ModificatorType,
  between: ModificatorType,
  first: ModificatorType,
  last: ModificatorType,
  children: PropTypes__default.node
};

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n        margin-left: ", "%;\n      "]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["", ""]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  padding-right: ", "rem;\n  padding-left: ", "rem;\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var ModificatorType$1 = PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.bool]);
var offsetProps = DIMENSION_NAMES.map(function (d) {
  return d + 'Offset';
});
var DimensionPropTypes = DIMENSION_NAMES.reduce(function (propTypes, dimension) {
  propTypes[dimension] = ModificatorType$1;
  propTypes[dimension + 'Offset'] = PropTypes__default.number;
  return propTypes;
}, {});
var Col = styled__default.div(_templateObject$3(), function (p) {
  return config$1(p).gutterWidth / 2;
}, function (p) {
  return config$1(p).gutterWidth / 2;
}, function (p) {
  return p.reverse && "\n    flex-direction: column-reverse;\n  ";
}, function (p) {
  return Object.keys(p).filter(function (k) {
    return ~DIMENSION_NAMES.indexOf(k);
  }).sort(function (k1, k2) {
    return DIMENSION_NAMES.indexOf(k1) - DIMENSION_NAMES.indexOf(k2);
  }).map(function (k) {
    return config$1(p).media[k](_templateObject2$2(), lodash_isinteger(p[k]) // Integer value
    ? "\n        flex-basis: " + 100 / config$1(p).gridSize * p[k] + "%;\n        max-width: " + 100 / config$1(p).gridSize * p[k] + "%;\n        display: block;\n      " // Boolean
    : p[k] // Auto-width
    ? "\n          flex-grow: 1;\n          flex-basis: 0;\n          max-width: 100%;\n          display: block;\n        " // Hide element
    : 'display: none;');
  });
}, function (p) {
  return Object.keys(p).filter(function (k) {
    return ~offsetProps.indexOf(k);
  }).map(function (k) {
    return config$1(p).media[k.replace(/Offset$/, '')](_templateObject3$2(), 100 / config$1(p).gridSize * p[k]);
  });
});
Col.displayName = 'Col';
Col.propTypes = _objectSpread2$2({}, DimensionPropTypes, {
  reverse: PropTypes__default.bool,
  children: PropTypes__default.node
});

var _templateObject$4;
var StyledColumn = styled__default(Col)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  @media only screen and (min-width: ", ") {\n    display: ", ";\n  }\n  @media only screen and (min-width: ", ") {\n    display: ", ";\n  }\n  @media only screen and (min-width: ", ") {\n    display: ", ";\n  }\n  @media only screen and (min-width: ", ") {\n    display: ", ";\n  }\n  align-items: ", ";\n  justify-content: ", ";\n  flex-direction: column;\n"])), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.flexboxgrid.breakpoints.xs, "em");
}, function (_ref2) {
  var xs = _ref2.xs;
  return xs === false ? 'none' : 'flex';
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.flexboxgrid.breakpoints.sm, "em");
}, function (_ref4) {
  var sm = _ref4.sm;
  return sm === false ? 'none' : 'flex';
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.flexboxgrid.breakpoints.md, "em");
}, function (_ref6) {
  var md = _ref6.md;
  return md === false ? 'none' : 'flex';
}, function (_ref7) {
  var theme = _ref7.theme;
  return "".concat(theme.flexboxgrid.breakpoints.lg, "em");
}, function (_ref8) {
  var lg = _ref8.lg;
  return lg === false ? 'none' : 'flex';
}, function (props) {
  return props.valign;
}, function (props) {
  return props.halign;
});

var Column = function Column(_ref) {
  var cols = _ref.cols,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      offset = _ref.offset,
      xsOffset = _ref.xsOffset,
      smOffset = _ref.smOffset,
      mdOffset = _ref.mdOffset,
      lgOffset = _ref.lgOffset,
      children = _ref.children,
      className = _ref.className,
      valign = _ref.valign,
      halign = _ref.halign;

  var colMode = function colMode(prop) {
    // if cols has been defined, and the xs - lg prop is not false or a number, set via cols prop
    if (cols && prop !== false && typeof prop !== 'number') {
      return cols;
    } // take the prop xs - lg prop if it exists


    if (prop || prop === false) {
      return prop;
    } // default to auto sizing columns


    return true;
  };

  var offsetMode = function offsetMode(prop) {
    if (offset && prop === null) {
      return offset;
    }

    return prop;
  };

  return /*#__PURE__*/React__default.createElement(StyledColumn, {
    xs: colMode(xs),
    sm: colMode(sm),
    md: colMode(md),
    lg: colMode(lg),
    xsOffset: offsetMode(xsOffset),
    smOffset: offsetMode(smOffset),
    mdOffset: offsetMode(mdOffset),
    lgOffset: offsetMode(lgOffset),
    valign: valign,
    halign: halign,
    className: "\n        ".concat(className, "\n      ")
  }, children);
};

Column.propTypes = {
  /**
   * Classes to be applied to the container element
   */
  className: PropTypes__default.string,

  /**
   * Col size for all breakpoints
   */
  cols: PropTypes__default.number,

  /**
   * Width in columns at xs screen sizes.
   * if true - enable auto sizing. If false, hide column otherwise specifiy amount of cols
   */
  xs: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.number]),

  /**
   * Width in columns at sm screen sizes.
   * if true - enable auto sizing. If false, hide column otherwise specifiy amount of cols
   */
  sm: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.number]),

  /**
   * Width in columns at md screen sizes.
   * if true - enable auto sizing. If false, hide column otherwise specifiy amount of cols
   */
  md: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.number]),

  /**
   * Width in columns at lg screen sizes.
   * if true - enable auto sizing. If false, hide column otherwise specifiy amount of cols
   */
  lg: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.number]),

  /**
   * offset for all breakpoints
   */
  offset: PropTypes__default.number,

  /**
   * Offset in columns at the xs screen size.
   */
  xsOffset: PropTypes__default.number,

  /**
   * Offset in columns at the sm screen size.
   */
  smOffset: PropTypes__default.number,

  /**
   * Offset in columns at the md screen size.
   */
  mdOffset: PropTypes__default.number,

  /**
   * Offset in columns at the lg screen size.
   */
  lgOffset: PropTypes__default.number,

  /**
   * The column contents.
   */
  children: PropTypes__default.oneOfType([PropTypes__default.arrayOf(PropTypes__default.node), PropTypes__default.node]),

  /**
   * The align-items property is related to CSS layout.
   */
  valign: PropTypes__default.oneOf(['flex-start', 'flex-end', 'center', 'baseline', 'stretch']),

  /**
   * The justify-content property is related to CSS layout.
   */
  halign: PropTypes__default.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'initial', 'inherit'])
};
Column.defaultProps = {
  className: '',
  cols: null,
  xs: null,
  sm: null,
  md: null,
  lg: null,
  offset: null,
  xsOffset: null,
  smOffset: null,
  mdOffset: null,
  lgOffset: null,
  valign: 'stretch',
  halign: 'initial',
  children: []
};

var flexboxgrid = {
  gridSize: 12,
  // columns
  gutterWidth: 1,
  // rem
  outerMargin: 2,
  // rem
  mediaQuery: 'only screen',
  breakpoints: {
    xs: 0,
    // em
    sm: 48,
    // em or 768px
    md: 64,
    // em or 1024px
    lg: 75,
    // em or 1200px,
    xl: 90 // em or 1440px

  }
};
/**
 * These are used by ManorContext (and breakpoint hooks) to determine the breakpoint. Ranges are:
 * (see useBreakpoint.js)
 * xs: 0 - 767px
 * sm 768px - 1023px
 * md: 1024px - 1199px
 * lg: 1200px - 1439px
 * xl: 1440px+
 */

var breakpoints = {
  xs: '767px',
  sm: '1023px',
  md: '1199px',
  lg: '1439px'
};
var breakpointsNumeric = {
  xs: 767,
  sm: 1023,
  md: 1199,
  lg: 1439
};
var colors = {
  brandMidnightBlue: '#001443',
  brandDarkBlue: '#001564',
  brandLightBlue: '#0f58ab',
  primary50: '#e7f0fb',
  primary100: '#c2d9f0',
  primary200: '#90bdea',
  primary300: '#5A94CE',
  primary400: '#3b80c5',
  primary500: '#0b60b7',
  primary600: '#004a8e',
  primary700: '#063a6d',
  primary800: '#042649',
  primary900: '#021324',
  hero50: '#e7f3ea',
  hero300: '#57ad69',
  hero400: '#339c48',
  hero500: '#0f8928',
  hero600: '#0d7522',
  hero700: '#0b611c',
  grey50: '#fafafa',
  grey100: '#f6f6f6',
  grey200: '#eeeeee',
  grey300: '#E0E0E0',
  grey400: '#c4c4c4',
  grey500: '#9e9e9e',
  grey600: '#757575',
  grey700: '#616161',
  grey800: '#424242',
  grey900: '#25130e',
  black: '#000000',
  white: '#FFFFFF',
  inputDisabledTextOnGray: '#606060',
  // grey 700
  inputPlacholderText: '#757575',
  // grey 600
  inputDisabledTextOnWhite: '#9e9e9e',
  // grey 500
  inputDisabledBackground: '#f6f6f6',
  // grey 200
  inputPrefilled: '#fbf9ec',
  inputPrefilledBorder: '#c39600',
  success50: '#dbf5d6',
  success500: '#0f8a28',
  success700: '#0a5c1b',
  error50: '#fbedee',
  error100: '#fbe4e6',
  error300: '#ef425e',
  error500: '#d2202f',
  error700: '#a41925',
  warning50: '#fff6ed',
  warning100: '#f5eebc',
  warning500: '#ff901d',
  warning700: '#d66c00',
  tooltipBackgroundDark: 'rgba(37, 19, 14, 0.95)',
  // opacity colors
  black25: 'rgba(0,0,0,0.25)',
  black50: 'rgba(0,0,0,0.50)',
  black75: 'rgba(0,0,0,0.75)',
  white25: 'rgba(255,255,255,0.25)',
  white50: 'rgba(255,255,255,0.50)',
  white75: 'rgba(255,255,255,0.75)'
};
var fontFamily = '"SourceSansPro", "Helvetica", "Arial"';
var fontSize = {
  '2xs': '1rem',
  // 10px
  xs: '1.2rem',
  // 12px
  sm: '1.4rem',
  // 14px
  base: '1.6rem',
  // 16px
  lg: '1.8rem',
  // 18px
  xl: '2rem',
  // 20px
  '2xl': '2.2rem',
  // 22px
  '3xl': '2.4rem',
  // 24px
  '4xl': '2.8rem',
  // 28px
  '5xl': '3.2rem',
  // 32px
  '6xl': '4.2rem' // 42px

};
var fontWeight = {
  hairline: '100',
  thin: '200',
  light: '300',
  normal: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
  extrabold: '800',
  black: '900'
};
var lineHeight = {
  none: '1',
  tighter: '1.2',
  tight: '1.25',
  snug: '1.4',
  normal: '1.5',
  relaxed: '1.625',
  loose: '2'
};
var spacing = {
  px: '0.1rem',
  //   1px
  0: '0',
  4: '0.4rem',
  8: '0.8rem',
  12: '1.2rem',
  16: '1.6rem',
  // 16px (just move the decimal place to the right one place)
  20: '2rem',
  24: '2.4rem',
  28: '2.8rem',
  32: '3.2rem',
  36: '3.6rem',
  40: '4rem',
  44: '4.4rem',
  48: '4.8rem',
  52: '5.2rem',
  56: '5.6rem',
  60: '6rem',
  64: '6.4rem',
  68: '6.8rem',
  72: '7.2rem',
  76: '7.6rem',
  80: '8rem',
  84: '8.4rem',
  88: '8.8rem',
  92: '9.2rem',
  96: '9.6rem',
  100: '10rem',
  104: '10.4rem',
  108: '10.8rem',
  112: '11.2rem',
  116: '11.6rem',
  120: '12rem',
  124: '12.4rem',
  128: '12.8rem',
  132: '13.2rem',
  136: '13.6rem',
  140: '14rem',
  144: '14.4rem',
  148: '14.8rem',
  152: '15.2rem',
  156: '15.6rem',
  160: '16rem',
  164: '16.4rem',
  168: '16.8rem',
  172: '17.2rem',
  176: '17.6rem',
  180: '18rem',
  184: '18.4rem',
  188: '18.8rem',
  192: '19.2rem',
  196: '19.6rem',
  200: '20rem',
  204: '20.4rem',
  208: '20.8rem',
  212: '21.2rem',
  216: '21.6rem',
  220: '22rem',
  224: '22.4rem',
  228: '22.8rem',
  232: '23.2rem',
  236: '23.6rem',
  240: '24rem',
  244: '24.4rem',
  248: '24.8rem',
  252: '25.2rem',
  256: '25.6rem',
  280: '28rem',
  360: '36rem',
  600: '60rem'
};
var borderRadius = {
  none: '0',
  sm: '0.2rem',
  //    2x
  default: '0.4rem',
  //    4px
  lg: '0.8rem',
  //    8px
  full: '999.9rem' // 9999px

};
var elevation = {
  lvl1: '0px 0.2rem 0.2rem rgba(208,206,206,0.5)',
  lvl2: '0px 0.5rem 0.8rem rgba(0,0,0,0.05)',
  lvl3: '0px 0.3rem 0.8rem rgba(0,0,0,0.1)',
  lvl4: '0px 0.3rem 0.8rem rgba(0,0,0,0.2)',
  lvl5: '0px 0.5rem 0.8rem rgba(0,0,0,0.2)',
  lvl6: '0px 0.8rem 0.8rem rgba(0,0,0,0.2)',
  none: 'none'
};
var boxShadow = {
  default: 'rgba(0, 0, 0, 0.1) 0 1rem 4rem 0',
  sm: '0 0.5rem 0.5rem 0 rgba(0,0,0,.1)',
  md: '0 0.4rem 0.8rem 0 rgba(0,0,0,0.12), 0 0.2rem 0.4rem 0 rgba(0,0,0,0.08)',
  lg: '0 1.5rem 3rem 0 rgba(0,0,0,0.11), 0 0.5rem 1.5rem 0 rgba(0,0,0,0.08)',
  inner: 'inset 0 0.2rem 0.4rem 0 rgba(0,0,0,0.06)',
  outline: '0 0 0 0.3rem rgba(52,144,220,0.5)',
  none: 'none',
  progress: '0 0.2rem 0.4rem 0 #DDDBDB',
  box: '0px 3px 8px rgba(0, 0, 0, 0.1)'
};
var maxWidth = {
  xs: '32rem',
  //  320px
  sm: '48rem',
  //  480px
  md: '64rem',
  //  640px
  lg: '80rem',
  //  800px
  xl: '96rem',
  //  960px
  '2xl': '112rem',
  // 1120px
  '3xl': '128rem',
  // 1280px
  '4xl': '144rem',
  // 1440px
  '5xl': '160rem',
  // 1600px
  '6xl': '190rem',
  // 1900px
  full: '100%'
};
var minHeight = {
  0: '0',
  full: '100%',
  screen: '100vh'
};
var minWidth = {
  0: '0',
  xs: '32rem',
  full: '100%'
};
var opacity = {
  0: '0',
  25: '0.25',
  50: '0.5',
  75: '0.75',
  100: '1'
};
var zIndex = {
  auto: 'auto',
  entry: '-1',
  max: '2147483647',
  // reserved for toast notifications
  0: '0',
  10: '10',
  20: '20',
  30: '30',
  40: '40',
  50: '50'
};
var transition = {
  default: 'all 200ms ease-out'
};
var borders = {
  invalid: "1px solid ".concat(colors.error500),
  transparent: '1px solid transparent',
  disabled: "1px solid ".concat(colors.grey300),
  component: "1px solid ".concat(colors.grey300),
  hover: "1px solid ".concat(colors.primary300),
  active: "1px solid ".concat(colors.primary500),
  prefill: "1px solid ".concat(colors.inputPrefilledBorder),
  dark: "1px solid ".concat(colors.brandMidnightBlue),
  focus: "1px solid ".concat(colors.primary500),
  expressive: "1px solid ".concat(colors.primary200)
};
var ctmTheme = {
  accordion: {
    background: colors.grey100,
    backgroundBody: colors.white,
    color: colors.grey900,
    chevronColor: colors.primary500
  },
  button: {
    borderRadius: borderRadius.default,
    fontWeight: fontWeight.bold,
    disabledBackgound: colors.grey500,
    disabledText: colors.white,
    shadows: {
      default: elevation.lvl4,
      hover: elevation.lvl5,
      focused: elevation.lvl3,
      disabled: elevation.none
    },
    hero: {
      background: colors.hero500,
      backgroundHover: colors.hero600,
      color: colors.white,
      fill: colors.white,
      backgroundInverted: colors.white,
      backgroundInvertedHover: colors.hero50,
      colorInverted: colors.hero500,
      fillInverted: colors.hero500
    },
    primary: {
      background: colors.primary500,
      backgroundHover: colors.primary600,
      color: colors.white,
      fill: colors.white,
      backgroundInverted: colors.white,
      backgroundInvertedHover: colors.primary50,
      colorInverted: colors.primary500,
      fillInverted: colors.primary500
    },
    secondary: {
      background: colors.white,
      backgroundHover: colors.primary50,
      color: colors.primary500,
      fill: colors.white,
      border: "1px solid ".concat(colors.primary500),
      backgroundInverted: colors.primary500,
      backgroundInvertedHover: colors.primary400,
      borderInverted: "1px solid ".concat(colors.white),
      colorInverted: colors.white,
      fillInverted: colors.white
    },
    tertiary: {
      background: 'transparent',
      backgroundHover: colors.primary50,
      color: colors.primary500,
      fill: colors.primary500,
      colorhover: colors.primary700
    }
  },
  card: {
    background: colors.white,
    border: borders.component,
    shadow: elevation.lvl1
  },
  checkbox: {
    color: colors.white,
    colorDisabled: colors.brandMidnightBlue,
    disabledOpacity: opacity[50],
    border: borders.component,
    borderHover: borders.hover,
    active: borders.active,
    prefilled: colors.inputPrefilled,
    prefilledBorder: "1px solid ".concat(colors.inputPrefilledBorder),
    invalid: "1px solid ".concat(colors.error500),
    iconPrefilled: colors.grey500,
    size: spacing[20],
    background: colors.white,
    backgroundChecked: colors.primary500,
    backgroundDisabled: colors.grey300,
    shadow: '0 0 0 1px rgba(0, 123, 255, .5)',
    borderRadius: borderRadius.sm,
    contentMargin: "0 ".concat(spacing[8]),
    boxedShadow: '0 3px 8px rgba(0, 0, 0, 0.1)'
  },
  container: {
    maxWidth: '120rem'
  },
  combo: {
    list: {
      color: colors.black,
      background: colors.white,
      shadow: boxShadow.md,
      item: {
        color: colors.grey700,
        backgroundHover: colors.grey100,
        borderFocus: borders.hover
      }
    },
    button: {
      border: borders.transparent,
      background: colors.primary50,
      borderFocus: borders.hover,
      backgroundHover: colors.primary50
    }
  },
  datepicker: {
    navigationButtonColor: colors.primary500,
    datepickerDayColor: colors.grey700,
    datepickerDayColorSelected: colors.white,
    datepickerDayBackground: colors.primary500,
    datepickerSelectedDayRangeColor: colors.black,
    datepickerSelectedDayRangeBackground: colors.primary50,
    datepickerSelectedDayEdgeBackground: colors.brandLightBlue,
    datepickerSelectedDayEdgeBackgroundHover: colors.primary400
  },
  dropdown: {
    height: spacing[44],
    color: colors.grey900,
    background: colors.white,
    backgroundDisabled: colors.grey100,
    disabledOpacity: '0.5',
    disabledSvgOpacity: '0.3',
    prefixBackground: colors.white,
    prefixColor: colors.grey600,
    shadow: boxShadow.box,
    caretFill: colors.primary500,
    colorActive: colors.brandLightBlue,
    backgroundActive: colors.grey100,
    list: {
      hoverBackground: colors.grey100,
      item: {
        borderFocus: borders.hover
      }
    }
  },
  emptyState: {
    containerMaxWidth: spacing[600],
    imgMaxWidth: spacing[280],
    imgMaxHeight: spacing[280]
  },
  featureList: {
    color: colors.success500
  },
  footer: {
    background: colors.white,
    transparent: 'transparent'
  },
  header: {
    background: colors.white,
    shadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    height: spacing[60],
    heightStuck: spacing[44],
    contact: {
      color: colors.primary500,
      hoverColor: colors.primary600
    }
  },
  input: {
    background: colors.white,
    height: spacing[44],
    color: colors.black,
    clearButton: {
      hoverColor: colors.primary500,
      color: colors.grey300,
      colorAutofill: colors.grey500
    },
    expressive: colors.primary500,
    expressiveDisabled: colors.grey50
  },
  label: {
    color: colors.grey900,
    inField: colors.grey600
  },
  logo: {
    heightSmall: spacing[32],
    heightLarge: spacing[44]
  },
  modal: {
    maxHeight: spacing[36],
    maxWidth: '745px'
  },
  notification: {
    color: colors.grey700,
    aaColor: colors.grey800,
    shadow: elevation.lvl3,
    success: {
      color: colors.success500,
      background: colors.hero50
    },
    warning: {
      color: colors.warning500,
      background: colors.warning50
    },
    error: {
      color: colors.error500,
      background: colors.error50
    },
    general: {
      color: colors.primary500,
      background: colors.primary50
    }
  },
  placeholder: {
    fontSize: fontSize.base,
    color: colors.grey600
  },
  loading: {
    background: colors.grey300,
    primary: colors.primary500,
    secondary: colors.hero500,
    fontSize: fontSize.base,
    containerBackground: 'transparent',
    borderRadius: borderRadius.lg
  },
  progress: {
    bar: {
      background: colors.white,
      backgroundValue: colors.grey300,
      height: spacing[6],
      progressBackground: colors.primary500
    },
    icon: {
      border: "2px solid ".concat(colors.black),
      borderDisabled: "2px solid ".concat(colors.grey500),
      disabledColor: colors.grey500,
      activeColor: colors.white,
      activeBackground: colors.black
    },
    tracker: {
      background: colors.white,
      backgroundValue: colors.grey100,
      colorValue: colors.primary50,
      backgroundCss: "\n        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#cfefc2+0,c3e4cf+100 */\n        background: ".concat(colors.primary50, ";  /* Old browsers   */\n        background ", "-moz-linear-gradient(left, ".concat(colors.primary50, " 0%, ").concat(colors.primary100, "  100%)"), "; /* FF3.6-15 */   \n        background: ", "-webkit-linear-gradient(left, ".concat(colors.primary50, " 0%, ").concat(colors.primary100, "  100%)"), "; /* Chrome10-25,Safari5.1-6 */\n        background: ", "linear-gradient(to right, ".concat(colors.primary50, " 0%, ").concat(colors.primary100, "  100%)"), "; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n        filter: ", "progid:DXImageTransform.Microsoft.gradient( startColorstr=".concat(colors.primary50, ", endColorstr=").concat(colors.primary100, ",GradientType=1 )"), ";  /* IE6-9 */\n      "),
      itemLinkColor: colors.black,
      progressStep: {
        color: colors.black,
        disabledColor: colors.grey500
      },
      item: {
        border: "1px solid ".concat(colors.grey300)
      }
    }
  },
  separator: {
    border: "1px solid ".concat(colors.black25)
  },
  slider: {
    margin: "".concat(spacing[20], " ").concat(spacing[16], " 0 ").concat(spacing[16]),
    disabled: colors.grey500,
    mark: {
      fontSize: fontSize.base,
      color: colors.grey800
    },
    rail: {
      color: colors.grey500,
      height: spacing[8],
      borderRadius: spacing[4]
    },
    track: {
      color: colors.primary500,
      height: spacing[8],
      borderRadius: spacing[4]
    },
    thumb: {
      height: spacing[20],
      width: spacing[20],
      border: "0.2rem solid ".concat(colors.grey100),
      boxShadow: '0px 3px 8px rgba(0,0,0,0.1)'
    },
    notch: {
      height: spacing[8],
      border: "1px solid ".concat(colors.grey500),
      defaultIndicator: {
        height: spacing[16],
        border: "2px solid ".concat(colors.primary500)
      }
    },
    label: {
      borderRadius: spacing[4],
      padding: "".concat(spacing[4], " ").concat(spacing[8])
    }
  },
  table: {
    rowHoverBackground: colors.grey100
  },
  tabs: {
    titleFontSize: fontSize.base,
    titleFontWeight: fontWeight.semibold,
    titleColor: colors.primary900,
    background: colors.primary50,
    buttonWrapShadow: "inset 0 -0.2rem 0 ".concat(colors.primary200),
    selectedTabShadow: "inset 0 -0.2rem 0 ".concat(colors.primary500)
  },
  toggle: {
    base: {
      labelColorHover: colors.primary300,
      background: colors.white,
      backgroundChecked: colors.primary500,
      color: colors.primary500,
      colorChecked: colors.white,
      colorDisabled: colors.grey300,
      shadowHover: elevation.lvl5
    },
    button: {
      text: colors.grey900,
      disabledColor: colors.grey500
    },
    multiSelect: {
      width: '30.4rem',
      borderChecked: "2px solid ".concat(colors.primary500)
    },
    greyed: {
      background: colors.grey500,
      color: colors.white
    }
  },
  tooltip: {
    iconColor: colors.primary500,
    iconColorVisible: colors.primary600,
    titleTextColor: colors.white,
    titleTextColorDark: colors.grey900,
    bodyTextColor: colors.white,
    bodyTextColorDark: colors.grey800,
    background: colors.tooltipBackgroundDark,
    backgroundLight: colors.white
  },
  drawer: {
    borderTop: "2px solid ".concat(colors.primary200),
    background: colors.white,
    closeIcon: colors.grey500,
    shadow: '0px 0px 6px rgba(0, 0, 0, 0.15)'
  },
  compareDrawer: {
    borderTop: "5px solid ".concat(colors.primary500),
    background: colors.white
  },
  emptyCard: {
    background: colors.grey50
  },
  tag: {
    background: colors.primary50,
    alert: colors.error50,
    alertTextColor: colors.error700,
    alertHover: "1px solid ".concat(colors.error500),
    regHover: "1px solid ".concat(colors.primary300),
    height: '100px'
  },
  breakpoints: breakpoints,
  breakpointsNumeric: breakpointsNumeric,
  borders: borders,
  colors: colors,
  fontFamily: fontFamily,
  fontSize: fontSize,
  spacing: spacing,
  borderRadius: borderRadius,
  boxShadow: boxShadow,
  fontWeight: fontWeight,
  lineHeight: lineHeight,
  maxWidth: maxWidth,
  minHeight: minHeight,
  minWidth: minWidth,
  opacity: opacity,
  zIndex: zIndex,
  transition: transition,
  elevation: elevation,
  flexboxgrid: flexboxgrid
};

var spacingPropTypes = function spacingPropTypes(props, propName, componentName) {
  // eslint-disable-next-line react/destructuring-assignment
  var values = props[propName];
  var spacing = Object.keys(ctmTheme.spacing);
  if (values === undefined || values.length === 0) return null;

  if (values.length > 4) {
    throw new Error("Invalid prop value (".concat(propName, "=[").concat(props[propName], "]) supplied to ").concat(componentName, ". Max array length is 4, representing each of the css values ").concat(propName, " can receive."));
  }

  values.forEach(function (el) {
    if (!spacing.includes(el)) {
      throw new Error("Invalid prop value (".concat(propName, "=[").concat(props[propName], "]) supplied to ").concat(componentName, ". Each array item must be a multiple of 4, which is a key for the internal manor spacing."));
    }
  });
  return null;
};

var applySpacing = function applySpacing(theme, spacingType, spacingValue) {
  var validCSS = spacingValue.map(function (v) {
    return theme.spacing[v] !== undefined ? theme.spacing[v] : '0';
  });
  var parsedResult = "".concat(spacingType, ": ").concat(validCSS.join(' '));
  return parsedResult;
};

function throttle(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var timer = null;
  return function throttled() {
    var _this = this;

    if (timer === null) {
      timer = setTimeout(function () {
        func.apply(_this.args);
        timer = null;
      }, wait);
    }
  };
}

var _templateObject$5;
var StyledContainer = styled__default.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: ", ";\n  margin: auto;\n  ", ";\n  max-width: ", ";\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.maxWidth.full;
}, function (_ref2) {
  var padding = _ref2.padding,
      theme = _ref2.theme;
  return applySpacing(theme, 'padding', padding);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.container.maxWidth;
});

function getTheme(gutterWidth) {
  return {
    gridSize: 12,
    // columns
    gutterWidth: gutterWidth / 10,
    // rem
    outerMargin: 2,
    // rem
    mediaQuery: 'only screen',
    breakpoints: {
      xs: 0,
      // em
      sm: 48,
      // em or 768px
      md: 64,
      // em or 1024px
      lg: 75,
      // em or 1200px,
      xl: 90 // em or 1440px

    }
  };
}

var ThemedContainer = function ThemedContainer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      padding = _ref.padding,
      gutterWidth = _ref.gutterWidth,
      theme = _ref.theme;
  // eslint-disable-next-line no-param-reassign,react/prop-types
  theme.flexboxgrid = getTheme(gutterWidth);
  return /*#__PURE__*/React__default.createElement(styled.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(StyledContainer, {
    className: className,
    padding: padding
  }, children));
};

var DynamicThemedContainer = styled.withTheme(ThemedContainer);

var Container = function Container(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      padding = _ref2.padding,
      gutterWidth = _ref2.gutterWidth;
  return /*#__PURE__*/React__default.createElement(DynamicThemedContainer, {
    className: className,
    padding: padding,
    gutterWidth: gutterWidth
  }, children);
};

Container.propTypes = {
  /**
   * Classes to be applied to the container element
   */
  className: PropTypes__default.string,
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node, PropTypes__default.arrayOf(PropTypes__default.node)]),

  /**
   * The left and right padding to be applied to the container
   */
  padding: spacingPropTypes,

  /**
   * The spacing between grid columns
   */
  gutterWidth: PropTypes__default.oneOf([4, 8, 12, 16, 24, 32])
};
Container.defaultProps = {
  className: '',
  children: [],
  padding: ['0'],
  gutterWidth: 32
};

var _templateObject$6;
var StyledContainer$1 = styled__default.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  margin: auto;\n  ", ";\n"])), function (_ref) {
  var padding = _ref.padding,
      theme = _ref.theme;
  return applySpacing(theme, 'padding', padding);
});

var ThemedFluidContainer = function ThemedFluidContainer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      padding = _ref.padding,
      gutterWidth = _ref.gutterWidth,
      theme = _ref.theme;
  // eslint-disable-next-line no-param-reassign,react/prop-types
  theme.flexboxgrid = getTheme(gutterWidth);
  return /*#__PURE__*/React__default.createElement(styled.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(StyledContainer$1, {
    className: className,
    padding: padding
  }, children));
};

var DynamicThemedFluidContainer = styled.withTheme(ThemedFluidContainer);

var FluidContainer = function FluidContainer(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      padding = _ref2.padding,
      gutterWidth = _ref2.gutterWidth;
  return /*#__PURE__*/React__default.createElement(DynamicThemedFluidContainer, {
    className: className,
    padding: padding,
    gutterWidth: gutterWidth
  }, children);
};

FluidContainer.propTypes = {
  /**
   * Classes to be applied to the FluidContainer element
   */
  className: PropTypes__default.string,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node, PropTypes__default.arrayOf(PropTypes__default.node)]),

  /**
   * The left and right padding to be applied to the container
   */
  padding: spacingPropTypes,

  /**
   * The spacing between grid columns
   */
  gutterWidth: PropTypes__default.oneOf([4, 8, 12, 16, 24, 32])
};
FluidContainer.defaultProps = {
  className: '',
  children: [],
  padding: ['0'],
  gutterWidth: 32
};

var _templateObject$7;
var StyledFlexRow = styled__default(Row)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  margin-bottom: ", ";\n  ", ";\n  ", ";\n  justify-content: ", ";\n"])), function (_ref) {
  var theme = _ref.theme,
      removeMarginBottom = _ref.removeMarginBottom;
  return removeMarginBottom ? 0 : theme.spacing[24];
}, function (props) {
  return props.flexWrap && styled.css(["flex-wrap:", ";"], props.flexWrap);
}, function (props) {
  return props.reverse && styled.css(["flex-direction:row-reverse;"]);
}, function (props) {
  return props.justify;
});

var Row$1 = function Row(_ref) {
  var children = _ref.children,
      className = _ref.className,
      reverse = _ref.reverse,
      removeMarginBottom = _ref.removeMarginBottom,
      flexWrap = _ref.flexWrap,
      justify = _ref.justify;
  return /*#__PURE__*/React__default.createElement(StyledFlexRow, {
    justify: justify,
    className: "row ".concat(className),
    reverse: reverse,
    removeMarginBottom: removeMarginBottom,
    flexWrap: flexWrap
  }, children);
};

Row$1.propTypes = {
  /**
   * Classes to be applied to the row element
   */
  className: PropTypes__default.string,

  /**
   * Flex-direction: reverse bool for the row
   */
  reverse: PropTypes__default.bool,

  /**
   * The children of the component
   */
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.array, PropTypes__default.object]),

  /**
   * Remove the default margin-bottom
   */
  removeMarginBottom: PropTypes__default.bool,

  /**
   * It defines whether the flex items are forced in a single line or can be flowed into multiple lines.
   */
  flexWrap: PropTypes__default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines alignment of a column
   */
  justify: PropTypes__default.oneOf(['flex-start', 'center', 'flex-end', 'space-around', 'space-between', 'initial', 'inherit'])
};
Row$1.defaultProps = {
  className: '',
  children: [],
  removeMarginBottom: false,
  reverse: false,
  flexWrap: 'wrap',
  justify: 'flex-start'
};

var _templateObject$8;
var StyledHR = styled__default.hr(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  border: none;\n  margin: 0;\n  padding: 0;\n  height: ", ";\n  width: ", ";\n  ", "\n\n  border-bottom: ", ";\n  border-right: ", ";\n"])), function (_ref) {
  var type = _ref.type;
  return type === 'horizontal' ? 0 : '100%';
}, function (_ref2) {
  var type = _ref2.type;
  return type === 'horizontal' ? '100%' : 0;
}, function (_ref3) {
  var noSpacing = _ref3.noSpacing;
  return !noSpacing && styled.css(["margin:", ";"], function (_ref4) {
    var type = _ref4.type,
        theme = _ref4.theme;
    return type === 'horizontal' ? "".concat(theme.spacing['32'], " 0") : "0 ".concat(theme.spacing['32']);
  });
}, function (_ref5) {
  var type = _ref5.type,
      theme = _ref5.theme;
  return type === 'horizontal' ? theme.separator.border : 'auto';
}, function (_ref6) {
  var type = _ref6.type,
      theme = _ref6.theme;
  return type === 'vertical' ? theme.separator.border : 'auto';
});

var Separator = function Separator(_ref) {
  var type = _ref.type,
      noSpacing = _ref.noSpacing,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement(StyledHR, {
    type: type,
    noSpacing: noSpacing,
    className: className
  });
};

Separator.propTypes = {
  /**
   * Direction of the Separator
   */
  type: PropTypes__default.oneOf(['horizontal', 'vertical']),

  /**
   * Remove spacing from the Separator
   */
  noSpacing: PropTypes__default.bool,

  /**
   * Classes to be applied to the Separator element
   */
  className: PropTypes__default.string
};
Separator.defaultProps = {
  type: 'horizontal',
  noSpacing: false,
  className: ''
};

var uuidv4 = require('uuid/v4');

var useId = function useId(propsId) {
  var randomId = React.useMemo(function () {
    return uuidv4();
  }, []);
  return propsId || randomId;
};

var _templateObject$9, _templateObject2$3, _templateObject3$3;
var StyledIcon = styled__default.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  pointer-events: none;\n  display: inherit;\n"])));
var disabledStyles = styled.css(["cursor:not-allowed;background:", ";color:", ";box-shadow:", ";border:none;:hover{box-shadow:", ";background:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.button.disabledBackgound;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.button.disabledText;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.button.shadows.disabled;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.button.shadows.disabled;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.button.disabledBackgound;
});
var baseButtonStyles = styled.css(["font-family:", ";border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;text-align:center;text-decoration:none;width:100%;font-size:", ";font-style:", ";line-height:", ";box-shadow:", ";border-radius:", ";padding:", ";margin-bottom:", ";transition:", ";font-weight:", ";> ", "{margin-right:", ";", ";}", ":focus{outline:none;}:hover{box-shadow:", ";}:active,:focus{box-shadow:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontFamily;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.base;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeight.normal;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.lineHeight.tighter;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.button.shadows.default;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.button.borderRadius;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.spacing[16];
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.spacing[16];
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.transition.default;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.button.fontWeight;
}, StyledIcon, function (_ref16) {
  var theme = _ref16.theme,
      iconButton = _ref16.iconButton;
  return iconButton ? 0 : theme.spacing[8];
}, function (_ref17) {
  var theme = _ref17.theme,
      iconButton = _ref17.iconButton;
  return iconButton && styled.css(["justify-content:center;min-width:", ";"], theme.spacing[24]);
}, function (_ref18) {
  var iconAlign = _ref18.iconAlign,
      theme = _ref18.theme;
  return iconAlign === 'right' && styled.css(["flex-direction:row-reverse;> ", "{margin-right:0;margin-left:", ";}"], StyledIcon, theme.spacing[8]);
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.button.shadows.hover;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.button.shadows.focused;
});
var heroVariant = styled.css(["color:", ";fill:", ";background:", ";@media (hover:hover) (pointer:fine){:hover{background:", ";}};", ""], function (_ref21) {
  var theme = _ref21.theme;
  return theme.button.hero.color;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.button.hero.fill;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.button.hero.background;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.button.hero.backgroundHover;
}, function (_ref25) {
  var inverted = _ref25.inverted;
  return inverted && styled.css(["background:", ";color:", ";fill:", ";box-shadow:", ";@media (hover:hover) (pointer:fine){:hover{background:", ";}};"], function (_ref26) {
    var theme = _ref26.theme;
    return theme.button.hero.backgroundInverted;
  }, function (_ref27) {
    var theme = _ref27.theme;
    return theme.button.hero.colorInverted;
  }, function (_ref28) {
    var theme = _ref28.theme;
    return theme.button.hero.fillInverted;
  }, function (_ref29) {
    var theme = _ref29.theme;
    return theme.button.shadows.default;
  }, function (_ref30) {
    var theme = _ref30.theme;
    return theme.button.hero.backgroundInvertedHover;
  });
});
var primaryVariant = styled.css(["color:", ";fill:", ";background:", ";@media (hover:hover) (pointer:fine){:hover{background:", ";}};", ""], function (_ref31) {
  var theme = _ref31.theme;
  return theme.button.primary.color;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.button.primary.fill;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.button.primary.background;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.button.primary.backgroundHover;
}, function (_ref35) {
  var inverted = _ref35.inverted;
  return inverted && styled.css(["background:", ";color:", ";fill:", ";@media (hover:hover) (pointer:fine){:hover{background:", ";}};"], function (_ref36) {
    var theme = _ref36.theme;
    return theme.button.primary.backgroundInverted;
  }, function (_ref37) {
    var theme = _ref37.theme;
    return theme.button.primary.colorInverted;
  }, function (_ref38) {
    var theme = _ref38.theme;
    return theme.button.primary.fillInverted;
  }, function (_ref39) {
    var theme = _ref39.theme;
    return theme.button.primary.backgroundInvertedHover;
  });
});
/**
 * @media (hover: hover): Prevent sticky hover effects for buttons on touch devices
 * If the browser supports proper/true/real/non-emulated hovering, then apply styles included when the button is hovered over.
 * ref:1: https://www.w3.org/TR/mediaqueries-4/#descdef-media-hover
 *     2: https://stackoverflow.com/questions/17233804/how-to-prevent-sticky-hover-effects-for-buttons-on-touch-devices
 */

var secondaryVariant = styled.css(["color:", ";fill:", ";border:", ";background:", ";@media (hover:hover) (pointer:fine){:hover{background:", ";}}", ""], function (_ref40) {
  var theme = _ref40.theme;
  return theme.button.secondary.color;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.button.secondary.fill;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.button.secondary.border;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.button.secondary.background;
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.button.secondary.backgroundHover;
}, function (_ref45) {
  var inverted = _ref45.inverted;
  return inverted && styled.css(["background:", ";color:", ";border:", ";fill:", ";@media (hover:hover) (pointer:fine){:hover{background:", ";}}"], function (_ref46) {
    var theme = _ref46.theme;
    return theme.button.secondary.backgroundInverted;
  }, function (_ref47) {
    var theme = _ref47.theme;
    return theme.button.secondary.colorInverted;
  }, function (_ref48) {
    var theme = _ref48.theme;
    return theme.button.secondary.borderInverted;
  }, function (_ref49) {
    var theme = _ref49.theme;
    return theme.button.secondary.fillInverted;
  }, function (_ref50) {
    var theme = _ref50.theme;
    return theme.button.secondary.backgroundInvertedHover;
  });
});
var tertiaryVariant = styled.css(["box-shadow:none;padding:", ";color:", ";fill:", ";background:", ";:hover,:focus{background:", ";box-shadow:none;}width:auto;margin-left:-", ";margin-right:-", ";"], function (_ref51) {
  var theme = _ref51.theme;
  return theme.spacing[8];
}, function (_ref52) {
  var theme = _ref52.theme;
  return theme.button.tertiary.color;
}, function (_ref53) {
  var theme = _ref53.theme;
  return theme.button.tertiary.fill;
}, function (_ref54) {
  var theme = _ref54.theme;
  return theme.button.tertiary.background;
}, function (_ref55) {
  var theme = _ref55.theme;
  return theme.button.tertiary.backgroundHover;
}, function (_ref56) {
  var theme = _ref56.theme;
  return theme.spacing[8];
}, function (_ref57) {
  var theme = _ref57.theme;
  return theme.spacing[8];
});
var BaseTag = styled__default.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", ";\n"])), baseButtonStyles, function (_ref58) {
  var variant = _ref58.variant;

  switch (variant) {
    case 'hero':
      return heroVariant;

    case 'primary':
      return primaryVariant;

    case 'secondary':
      return secondaryVariant;

    case 'tertiary':
      return tertiaryVariant;

    default:
      return heroVariant;
  }
}, function (_ref59) {
  var disabled = _ref59.disabled,
      href = _ref59.href;
  return disabled && !href && disabledStyles;
});
var StyledButtonWrap = styled__default.span(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 1 100%;\n  width: ", ";\n  & {\n    font-family: ", ";\n  }\n"])), function (_ref60) {
  var width = _ref60.width;
  return width;
}, function (_ref61) {
  var theme = _ref61.theme;
  return theme.fontFamily;
});

var Button = function Button(_ref) {
  var trackingLabel = _ref.trackingLabel,
      propsId = _ref.id,
      variant = _ref.variant,
      inverted = _ref.inverted,
      disabled = _ref.disabled,
      icon = _ref.icon,
      iconAlign = _ref.iconAlign,
      href = _ref.href,
      target = _ref.target,
      rel = _ref.rel,
      handleClick = _ref.handleClick,
      tagType = _ref.tagType,
      width = _ref.width,
      style = _ref.style,
      children = _ref.children,
      className = _ref.className,
      iconButton = _ref.iconButton;
  var id = useId(propsId);

  var _useContext = React.useContext(manorProvider.ManorContext),
      trackInteraction = _useContext.trackInteraction;

  var renderContent = function renderContent() {
    if (icon) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledIcon, null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
        icon: icon,
        size: "1x"
      })), children);
    }

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
  };

  var clickHandler = React.useCallback(function (e) {
    trackInteraction('Click', 'Button', variant, trackingLabel, trackingLabel);

    if (handleClick) {
      handleClick(e);
    }
  }, [handleClick, trackingLabel, trackInteraction, variant]);

  var renderButton = function renderButton() {
    var isButton = !href.length > 0;
    return /*#__PURE__*/React__default.createElement(BaseTag, {
      as: isButton ? 'button' : 'a',
      onClick: clickHandler,
      id: id,
      variant: variant,
      iconAlign: iconAlign,
      inverted: inverted,
      disabled: disabled,
      href: isButton ? null : href,
      target: isButton ? null : target,
      rel: isButton ? null : rel,
      type: isButton ? tagType : null,
      style: style,
      className: className,
      iconButton: iconButton
    }, renderContent());
  };

  return /*#__PURE__*/React__default.createElement(StyledButtonWrap, {
    variant: variant,
    width: width
  }, renderButton());
};

Button.propTypes = {
  /**
   * A descriptive label used in tracking user interactions with this component
   */
  trackingLabel: PropTypes__default.string.isRequired,

  /**
   * Unique identifier for the button
   */
  id: PropTypes__default.string,

  /**
   * The button/link contents
   */
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node, PropTypes__default.arrayOf(PropTypes__default.node)]),

  /**
   * Defines the type of button to be used. Defaults to `primary`. available types are `primary`, `secondary`,
   * `tertiary`, `text`, `link`, and `footer-link`.
   */
  variant: PropTypes__default.oneOf(['hero', 'primary', 'secondary', 'tertiary']),

  /**
   * Inverts the button. Tertiary doesn't have an inverted mode as its a ghost button
   */
  inverted: PropTypes__default.bool,

  /**
   * Defines if the button is disabled or not. Defaults to false.
   */
  disabled: PropTypes__default.bool,

  /**
   * The FontAwesome icon to be supplied with the button. Defaults to none.
   */
  icon: PropTypes__default.oneOfType([PropTypes__default.object, // eslint-disable-line
  PropTypes__default.string]),

  /**
   * Shift the icon to the right, content to the left. Defaults to false.
   */
  iconAlign: PropTypes__default.oneOf(['left', 'right']),

  /**
   * Defines the `<a>` link. Defaults to `#`.
   */
  href: PropTypes__default.string,

  /**
   * Defines if the `<a>` should have a target attribute.
   */
  target: PropTypes__default.string,

  /**
   * Specifies the rel, for example "nofollow" can be supplied
   */
  rel: PropTypes__default.string,

  /**
   * Specifies the type attribute to add to a button tag
   */
  tagType: PropTypes__default.string,

  /**
   * Manually set the width of a button
   */
  width: PropTypes__default.string,

  /**
   * Overide the css with inline styles if needed
   */
  style: PropTypes__default.objectOf(PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number])),

  /**
   * Classes to be applied to the Button component
   */
  className: PropTypes__default.string,

  /**
   * Pass the button a custom click function
   */
  handleClick: PropTypes__default.func,

  /**
   * Sets whether the button is purely icon only
   */
  iconButton: PropTypes__default.bool
};
Button.defaultProps = {
  id: null,
  variant: 'hero',
  inverted: false,
  children: '',
  disabled: false,
  icon: null,
  iconAlign: 'left',
  href: '',
  target: '#',
  rel: '',
  tagType: '',
  style: {},
  width: '100%',
  handleClick: null,
  className: '',
  iconButton: false
};

var _templateObject$a;
var StyledOverlay = styled__default.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: ", ";\n  margin: 0;\n  padding: 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.zIndex[30];
});

var Overlay = function Overlay(_ref) {
  var visible = _ref.visible,
      opacityLevel = _ref.opacityLevel,
      handleClick = _ref.handleClick;
  return visible && /*#__PURE__*/React__default.createElement(StyledOverlay, {
    className: "overlay",
    style: {
      background: "rgba(0,0,0,".concat(opacityLevel, ")")
    },
    "aria-label": "overlay",
    tabIndex: "-1",
    role: "option",
    "aria-selected": false,
    onClick: handleClick
  });
};

Overlay.propTypes = {
  /**
   *  Defines overlay visibility.
   */
  visible: PropTypes__default.bool,

  /**
   *  Defines opacity level of the background(from 0 to 1).
   */
  opacityLevel: PropTypes__default.number,

  /**
   * Called when the overlay is clicked
   */
  handleClick: PropTypes__default.func
};
Overlay.defaultProps = {
  visible: false,
  opacityLevel: 0.7,
  handleClick: null
};

var _templateObject$b;

var StyledTypography = styled__default(function (_ref) {
  var component = _ref.component,
      variant = _ref.variant,
      align = _ref.align,
      color = _ref.color,
      display = _ref.display,
      noWrap = _ref.noWrap,
      helpTextFontSize = _ref.helpTextFontSize,
      otherProps = _objectWithoutProperties(_ref, ["component", "variant", "align", "color", "display", "noWrap", "helpTextFontSize"]);

  var Tag = component; // eslint-disable-next-line react/jsx-props-no-spreading

  return /*#__PURE__*/React__default.createElement(Tag, otherProps);
})(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  margin-top: 0;\n  margin-bottom: 0;\n  font-family: SourceSansPro, Arial, sans-serif;\n  text-align: ", ";\n  color: ", ";\n  font-weight: ", ";\n  ", ";\n  ", ";\n  // H1\n  ", ";\n  // H2\n  ", ";\n  // H3\n  ", ";\n  // H4\n  ", ";\n  // H5\n  ", ";\n  // H6\n  ", ";\n  // SUBTITLE1\n  ", ";\n  // SUBTITLE2\n  ", ";\n  // BODY1\n  ", ";\n  // BODY2\n  ", ";\n  // CAPTION\n  ", ";\n  // HELPTEXT\n  ", ";\n  // OVERLINE\n  ", ";\n  // SRONLY\n  ", ";\n"])), function (_ref2) {
  var align = _ref2.align;
  return align;
}, function (_ref3) {
  var color = _ref3.color;
  return color;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeight.normal;
}, function (_ref5) {
  var display = _ref5.display;
  return display && styled.css(["display:", ";"], display);
}, function (_ref6) {
  var noWrap = _ref6.noWrap;
  return noWrap && styled.css(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
}, function (_ref7) {
  var theme = _ref7.theme,
      variant = _ref7.variant;
  return variant === 'h1' && styled.css(["line-height:", ";font-size:", ";@media only screen and (min-width:", "){font-size:", ";}@media only screen and (min-width:", "){font-size:", ";}"], theme.lineHeight.tight, theme.fontSize['4xl'], "".concat(theme.breakpoints.sm), theme.fontSize['5xl'], "".concat(theme.breakpoints.md), theme.fontSize['6xl']);
}, function (_ref8) {
  var theme = _ref8.theme,
      variant = _ref8.variant;
  return variant === 'h2' && styled.css(["line-height:", ";font-size:", ";@media only screen and (min-width:", "){font-size:", ";}@media only screen and (min-width:", "){font-size:", ";}"], theme.lineHeight.tighter, theme.fontSize['2xl'], "".concat(theme.breakpoints.sm), theme.fontSize['3xl'], "".concat(theme.breakpoints.md), theme.fontSize['5xl']);
}, function (_ref9) {
  var theme = _ref9.theme,
      variant = _ref9.variant;
  return variant === 'h3' && styled.css(["line-height:", ";font-size:", ";@media only screen and (min-width:", "){font-size:", ";}@media only screen and (min-width:", "){font-size:", ";}"], theme.lineHeight.tight, theme.fontSize.lg, "".concat(theme.breakpoints.sm), theme.fontSize.xl, "".concat(theme.breakpoints.md), theme.fontSize['3xl']);
}, function (_ref10) {
  var theme = _ref10.theme,
      variant = _ref10.variant;
  return variant === 'h4' && styled.css(["line-height:", ";font-size:", ";@media only screen and (min-width:", "){font-size:", ";}"], theme.lineHeight.tighter, theme.fontSize.lg, "".concat(theme.breakpoints.md), theme.fontSize.xl);
}, function (_ref11) {
  var theme = _ref11.theme,
      variant = _ref11.variant;
  return variant === 'h5' && styled.css(["line-height:", ";font-weight:", ";font-size:", ";@media only screen and (min-width:", "){line-height:", ";font-size:", ";}"], theme.lineHeight.snug, theme.fontWeight.semibold, theme.fontSize.base, "".concat(theme.breakpoints.md), theme.lineHeight.tighter, theme.fontSize.lg);
}, function (_ref12) {
  var theme = _ref12.theme,
      variant = _ref12.variant;
  return variant === 'h6' && styled.css(["line-height:", ";font-weight:", ";font-size:", ";@media only screen and (min-width:", "){line-height:", ";font-size:", ";}"], theme.lineHeight.normal, theme.fontWeight.semibold, theme.fontSize.sm, "".concat(theme.breakpoints.md), theme.lineHeight.tight, theme.fontSize.base);
}, function (_ref13) {
  var theme = _ref13.theme,
      variant = _ref13.variant;
  return variant === 'subtitle1' && styled.css(["font-weight:", ";line-height:", ";font-size:", ";"], theme.fontWeight.normal, theme.lineHeight.snug, theme.fontSize.lg);
}, function (_ref14) {
  var theme = _ref14.theme,
      variant = _ref14.variant;
  return variant === 'subtitle2' && styled.css(["font-weight:", ";line-height:", ";font-size:", ";"], theme.fontWeight.bold, theme.lineHeight.snug, theme.fontSize.base);
}, function (_ref15) {
  var theme = _ref15.theme,
      variant = _ref15.variant;
  return variant === 'body1' && styled.css(["line-height:", ";font-size:", ";"], theme.lineHeight.snug, theme.fontSize.base);
}, function (_ref16) {
  var theme = _ref16.theme,
      variant = _ref16.variant;
  return variant === 'body2' && styled.css(["line-height:", ";font-size:", ";"], theme.lineHeight.snug, theme.fontSize.sm);
}, function (_ref17) {
  var theme = _ref17.theme,
      variant = _ref17.variant;
  return variant === 'caption' && styled.css(["line-height:", ";font-size:", ";letter-spacing:0.15rem;font-weight:", ";text-transform:uppercase;color:", ";"], theme.lineHeight.tight, theme.fontSize['2xs'], theme.fontWeight.normal, theme.colors.grey600);
}, function (_ref18) {
  var theme = _ref18.theme,
      variant = _ref18.variant;
  return variant === 'helpText' && styled.css(["font-weight:", ";color:", ";", ";"], theme.fontWeight.normal, theme.colors.grey600, function (_ref19) {
    var helpTextFontSize = _ref19.helpTextFontSize;
    return helpTextFontSize && styled.css(["font-size:", ";"], theme.fontSize["".concat(helpTextFontSize)]);
  });
}, function (_ref20) {
  var theme = _ref20.theme,
      variant = _ref20.variant;
  return variant === 'overline' && styled.css(["line-height:", ";font-size:", ";letter-spacing:0.02rem;font-weight:", ";text-transform:uppercase;color:", ";"], theme.lineHeight.tight, theme.fontSize['2xs'], theme.fontWeight.semibold, theme.colors.placeholderText);
}, function (_ref21) {
  var variant = _ref21.variant;
  return variant === 'srOnly' && styled.css(["width:1px;height:1px;overflow:hidden;position:absolute;"]);
});

var variantTags = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'p',
  subtitle2: 'p',
  body1: 'p',
  body2: 'p',
  caption: 'caption',
  helpText: 'helpText',
  overline: 'span',
  srOnly: 'span'
};

var Typography = function Typography(_ref) {
  var variant = _ref.variant,
      component = _ref.component,
      children = _ref.children,
      align = _ref.align,
      color = _ref.color,
      display = _ref.display,
      noWrap = _ref.noWrap,
      style = _ref.style,
      className = _ref.className,
      helpTextFontSize = _ref.helpTextFontSize,
      props = _objectWithoutProperties(_ref, ["variant", "component", "children", "align", "color", "display", "noWrap", "style", "className", "helpTextFontSize"]);

  var componentToRender = component || variantTags[variant];
  return /*#__PURE__*/React__default.createElement(StyledTypography, _extends({
    component: componentToRender,
    variant: variant,
    align: align,
    color: color,
    display: display,
    noWrap: noWrap,
    style: style,
    className: className,
    helpTextFontSize: helpTextFontSize // eslint-disable-next-line react/jsx-props-no-spreading

  }, props), children);
};

Typography.propTypes = {
  /**
   * The typography style to render
   */
  variant: PropTypes__default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'helpText', 'overline', 'srOnly']),

  /**
   * The component used for the root node (e.g. p, div, span...)
   */
  component: PropTypes__default.string,

  /**
   * Set the text-align on the component
   */
  align: PropTypes__default.oneOf(['left', 'center', 'right', 'justify']),

  /**
   * The color of the component
   */
  color: PropTypes__default.string,

  /**
   * Controls the display type
   */
  display: PropTypes__default.oneOf(['initial', 'block', 'inline']),

  /**
   * If true the text will not wrap, but instead will truncate with a text
   * overflow ellipsis. Note that text overflow can only happen with block
   * or inline-block level elements (the element needs to have a width in order
   * to overflow)
   */
  noWrap: PropTypes__default.bool,

  /**
   * Additional styles - if using this a div will be rendered within the typography element,
   *  which may cause errors (e.g. you cannot have a div within a p tag). If so, use the `component` prop
   *  to change the HTML element being rendered (e.g. `component="div"`).
   */
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes__default.object,
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node, PropTypes__default.arrayOf(PropTypes__default.node)]),

  /**
   * Classes to be applied to the rendered element
   */
  className: PropTypes__default.string,

  /**
   * Set this value to override helpText default font size (2xs). Note that
   * it will only take effect when variant set to 'helpText'.
   *
   * The array list must match the keys in theme.fontSize
   */
  helpTextFontSize: PropTypes__default.oneOf(['', '2xs', 'xs', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl'])
};
Typography.defaultProps = {
  variant: 'body1',
  component: null,
  align: 'left',
  color: 'inherit',
  display: null,
  noWrap: false,
  children: [],
  style: null,
  className: '',
  helpTextFontSize: ''
};

var _templateObject$c, _templateObject2$4, _templateObject3$4, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;
// It mainly covers default behaviour and also accommodates padding in height calcs.

var defaultModalHeaderHeight = 68;
var supplementaryHeaderPadding = 20;
var StyledAlignment = styled__default.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  right: 0;\n  pointer-events: none;\n  z-index: ", ";\n"])), function (_ref) {
  var zIndex = _ref.zIndex;
  return zIndex;
});
var animateIn = styled.keyframes(["from{transform:translateY(-20%);opacity:0;}to{transform:translateY(0);opacity:1;}"]);
var StyledModal = styled__default.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  background: ", ";\n  box-shadow: ", ";\n  z-index: inherit;\n  max-width: 76.8rem;\n  min-width: 35rem;\n  width: ", ";\n  ", "\n  pointer-events: auto;\n  position: relative;\n  animation-name: ", ";\n  animation-duration: 0.3s;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grey100;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.boxShadow.lg;
}, function (_ref4) {
  var desktop = _ref4.desktop;
  return desktop ? '76.8rem' : '100%';
}, function (_ref5) {
  var dynamicHeight = _ref5.dynamicHeight;
  return !dynamicHeight && styled.css(["height:", ";"], function (_ref6) {
    var desktop = _ref6.desktop;
    return desktop ? '80%' : '100%';
  });
}, animateIn);
var StyledModalHeader = styled__default.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  background: ", ";\n  padding: 1.9rem ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme,
      desktop = _ref7.desktop;
  return desktop ? theme.colors.white : theme.colors.grey100;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.spacing[24];
});
var StyledTitleContainer = styled__default.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  display: flex;\n  h3 {\n    margin: 0;\n  }\n"])));
var StyledTitle = styled__default.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  background: ", ";\n  display: inline-block;\n  font-size: ", ";\n"])), function (_ref9) {
  var theme = _ref9.theme,
      desktop = _ref9.desktop;
  return desktop ? theme.colors.white : theme.colors.grey100;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSize['3xl'];
});
var StyledTitleIcon = styled__default.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  color: ", ";\n  display: inline-block;\n  font-size: ", ";\n  margin-right: ", ";\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.primary500;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontSize['3xl'];
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.spacing[16];
});
var StyledCloseIcon = styled__default.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  z-index: inherit;\n  color: ", ";\n  font-size: ", ";\n"])), function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.grey600;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontSize['3xl'];
});
var StyledContent = styled__default.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  padding: ", ";\n  height: ", ";\n  overflow-y: ", ";\n  overflow-x: ", ";\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return "".concat(theme.spacing[20], " ").concat(theme.spacing[24], " 0");
}, function (_ref17) {
  var showSupplementaryBar = _ref17.showSupplementaryBar,
      desktop = _ref17.desktop,
      modalHeaderBarHeight = _ref17.modalHeaderBarHeight;
  return "calc(100% - ".concat(desktop && showSupplementaryBar ? (modalHeaderBarHeight || defaultModalHeaderHeight) + 88 : modalHeaderBarHeight + supplementaryHeaderPadding || defaultModalHeaderHeight, "px)");
}, function (_ref18) {
  var desktop = _ref18.desktop;
  return desktop ? '' : 'scroll';
}, function (_ref19) {
  var desktop = _ref19.desktop;
  return desktop ? '' : 'hidden';
});
var StyledContentChildren = styled__default.div(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n  height: ", ";\n  min-height: ", ";\n  overflow: ", ";\n"])), function (_ref20) {
  var theme = _ref20.theme,
      desktop = _ref20.desktop;
  return desktop ? "calc(100% - ".concat(theme.spacing[80], ")") : '';
}, function (_ref21) {
  var theme = _ref21.theme,
      desktop = _ref21.desktop,
      showSupplementaryBar = _ref21.showSupplementaryBar,
      supplementaryBarHeight = _ref21.supplementaryBarHeight;
  return desktop ? '' : "calc(100% - ".concat(theme.spacing[92], " ").concat(showSupplementaryBar && supplementaryBarHeight ? "- ".concat(supplementaryBarHeight, "px") : '', ")");
}, function (_ref22) {
  var desktop = _ref22.desktop;
  return desktop ? 'auto' : '';
});
var StyledContentButtons = styled__default.div(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n  background: white;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0 ", ";\n  margin: 0 -", " 0;\n  height: ", ";\n  border-top: ", ";\n"])), function (_ref23) {
  var theme = _ref23.theme;
  return theme.spacing[32];
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.spacing[24];
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.spacing[80];
}, function (_ref26) {
  var theme = _ref26.theme;
  return "1px solid ".concat(theme.colors.grey100);
});
var StyledPrimaryButton = styled__default.div(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));
var StyledSecondaryButton = styled__default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));
var StyledSupplementaryBar = styled__default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  background: ", ";\n  padding: ", " ", ";\n  margin: 0 -", " 0;\n"])), function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.primary50;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.spacing[16];
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.spacing[32];
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.spacing[24];
});
var StyledSupplementaryBarItem = styled__default.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  align-items: center;\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  margin-right: ", ";\n  margin-bottom: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n"])), function (_ref31) {
  var theme = _ref31.theme;
  return theme.colors.primary500;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.spacing[16];
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.spacing[0];
}, function (_ref34) {
  var theme = _ref34.theme,
      desktop = _ref34.desktop;
  return theme.spacing[desktop ? 0 : 8];
}, function (_ref35) {
  var theme = _ref35.theme,
      desktop = _ref35.desktop;
  return theme.spacing[desktop ? 0 : 8];
});
var StyledSupplementaryBarItemText = styled__default.span(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n  margin-right: ", ";\n  font-size: ", ";\n  h6, p {\n    margin: 0;\n  }\n"])), function (_ref36) {
  var theme = _ref36.theme;
  return theme.spacing[0];
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.spacing[8];
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.fontSize.base;
});
var StyledSupplementaryBarItemIcon = styled__default.span(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n  margin-right: ", ";\n  font-size: ", ";\n"])), function (_ref39) {
  var theme = _ref39.theme;
  return theme.spacing[0];
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.spacing[8];
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.fontSize.base;
});
var StyledFlexContainer = styled__default.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: ", ";\n  padding-bottom: ", ";\n"])), function (_ref42) {
  var theme = _ref42.theme;
  return theme.spacing[8];
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.spacing[8];
});
var SeparatorContainer = styled__default.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  display: none;\n  height: 100%;\n\n  @media only screen and (min-width: ", ") {\n    display: block;\n    margin-right: ", ";\n  }\n"])), function (_ref44) {
  var theme = _ref44.theme;
  return "".concat(theme.flexboxgrid.breakpoints.sm, "em");
}, function (_ref45) {
  var theme = _ref45.theme;
  return theme.spacing[16];
});
var StyledLink = styled__default.a(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  text-decoration: none;\n  h6 {\n    color: ", ";\n  }\n"])), function (_ref46) {
  var theme = _ref46.theme;
  return theme.colors.primary500;
});

var Wrapper = function Wrapper(_ref) {
  var trapFocus = _ref.trapFocus,
      focusTrapOptions = _ref.focusTrapOptions,
      children = _ref.children;

  if (trapFocus) {
    return /*#__PURE__*/React__default.createElement(focusTrapReact, {
      focusTrapOptions: focusTrapOptions
    }, children);
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
};

var Modal = function Modal(_ref2) {
  var trackingLabel = _ref2.trackingLabel,
      propsId = _ref2.id,
      dynamicHeight = _ref2.dynamicHeight,
      title = _ref2.title,
      titleIcon = _ref2.titleIcon,
      visible = _ref2.visible,
      handleClose = _ref2.handleClose,
      className = _ref2.className,
      children = _ref2.children,
      overlay = _ref2.overlay,
      overlayOpacity = _ref2.overlayOpacity,
      primaryActionTitle = _ref2.primaryActionTitle,
      secondaryActionTitle = _ref2.secondaryActionTitle,
      handleOverlayClick = _ref2.handleOverlayClick,
      handlePrimaryActionClick = _ref2.handlePrimaryActionClick,
      handleSecondaryActionClick = _ref2.handleSecondaryActionClick,
      showSupplementaryBar = _ref2.showSupplementaryBar,
      supplementaryBarOptions = _ref2.supplementaryBarOptions,
      zIndex = _ref2.zIndex,
      trapFocus = _ref2.trapFocus,
      focusTrapOptions = _ref2.focusTrapOptions,
      disableBodyScrollLock = _ref2.disableBodyScrollLock;
  var id = useId(propsId);
  var headerBarRef = React.useRef(null);
  var supplementaryBarRef = React.useRef(null);

  var _useState = React.useState(),
      _useState2 = _slicedToArray(_useState, 2),
      headerBarHeight = _useState2[0],
      setHeaderBarHeight = _useState2[1];

  var _useState3 = React.useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      supplementaryBarHeight = _useState4[0],
      setSupplementaryBarHeight = _useState4[1];

  var _useContext = React.useContext(manorProvider.ManorContext),
      isDesktop = _useContext.isDesktop;

  var showRequestCall = supplementaryBarOptions.showRequestCall,
      showChatOnline = supplementaryBarOptions.showChatOnline,
      phoneNumber = supplementaryBarOptions.phoneNumber;
  var classNames = "\n    ".concat(className, "\n  ");
  React.useLayoutEffect(function () {
    if (headerBarRef) {
      var handleHeaderBarResize = function handleHeaderBarResize() {
        if (headerBarRef.current) {
          setHeaderBarHeight(headerBarRef.current.offsetHeight);
        }
      };

      var throttledHeaderBarResize = throttle(handleHeaderBarResize, 25);
      window.addEventListener('resize', throttledHeaderBarResize);
      return function () {
        window.removeEventListener('resize', throttledHeaderBarResize);
      };
    }

    return null;
  }, [headerBarRef, headerBarHeight]);
  React.useEffect(function () {
    if (headerBarRef && headerBarRef.current) {
      setHeaderBarHeight(headerBarRef.current.offsetHeight);
    }
  }, [visible]);
  React.useLayoutEffect(function () {
    if (supplementaryBarRef) {
      var handleResize = function handleResize() {
        if (supplementaryBarRef.current) {
          setSupplementaryBarHeight(supplementaryBarRef.current.offsetHeight);
        }
      };

      var throttledResize = throttle(handleResize, 25);
      window.addEventListener('resize', throttledResize);
      return function () {
        window.removeEventListener('resize', throttledResize);
      };
    }

    return null;
  }, [supplementaryBarRef, supplementaryBarHeight]);
  React.useEffect(function () {
    if (supplementaryBarRef && supplementaryBarRef.current) {
      setSupplementaryBarHeight(supplementaryBarRef.current.offsetHeight);
    }
  }, [visible]);

  var Header = function Header() {
    return /*#__PURE__*/React__default.createElement(StyledModalHeader, {
      ref: headerBarRef,
      desktop: isDesktop
    }, /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Row$1, {
      removeMarginBottom: true
    }, /*#__PURE__*/React__default.createElement(Column, {
      halign: "center"
    }, /*#__PURE__*/React__default.createElement(StyledTitleContainer, null, titleIcon && /*#__PURE__*/React__default.createElement(StyledTitleIcon, {
      desktop: isDesktop
    }, titleIcon), title && /*#__PURE__*/React__default.createElement(StyledTitle, {
      desktop: isDesktop
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h2"
    }, title)))), /*#__PURE__*/React__default.createElement(Column, {
      cols: 1,
      valign: "flex-end",
      halign: "center"
    }, /*#__PURE__*/React__default.createElement(StyledCloseIcon, {
      className: "icon-close",
      onClick: handleClose,
      onKeyPress: handleClose,
      "aria-label": "Close Modal",
      tabIndex: "0",
      role: "button",
      "aria-pressed": "false"
    }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faTimes
    }))))));
  };

  var ActionButtons = function ActionButtons() {
    var showButtons = secondaryActionTitle || primaryActionTitle;

    if (!showButtons) {
      return null;
    }

    return /*#__PURE__*/React__default.createElement(StyledContentButtons, null, secondaryActionTitle && /*#__PURE__*/React__default.createElement(StyledSecondaryButton, null, /*#__PURE__*/React__default.createElement(Button, {
      id: "secondary-btn",
      variant: "tertiary",
      style: {
        margin: 0,
        display: 'inline-block',
        padding: '1.2rem'
      },
      handleClick: handleSecondaryActionClick,
      trackingLabel: "Secondary button for ".concat(trackingLabel)
    }, secondaryActionTitle)), primaryActionTitle && /*#__PURE__*/React__default.createElement(StyledPrimaryButton, null, /*#__PURE__*/React__default.createElement(Button, {
      id: "primary-btn",
      variant: "primary",
      style: {
        margin: 0,
        display: 'inline-block',
        padding: '1.2rem'
      },
      handleClick: handlePrimaryActionClick,
      trackingLabel: "Primary button for ".concat(trackingLabel)
    }, primaryActionTitle)));
  };

  var SupplementaryBar = function SupplementaryBar() {
    var showCallUs = (showRequestCall || showChatOnline) && phoneNumber;

    if (!showSupplementaryBar) {
      return null;
    }

    return /*#__PURE__*/React__default.createElement(StyledSupplementaryBar, {
      id: "supplementary-bar",
      ref: supplementaryBarRef,
      desktop: isDesktop
    }, /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Row$1, {
      removeMarginBottom: true
    }, /*#__PURE__*/React__default.createElement(Column, {
      cols: 12
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body1"
    }, "Need help? Talk to one of our experts"))), /*#__PURE__*/React__default.createElement(Row$1, {
      removeMarginBottom: true
    }, /*#__PURE__*/React__default.createElement(Column, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex',
        flexWrap: 'wrap'
      }
    }, showRequestCall && /*#__PURE__*/React__default.createElement(StyledSupplementaryBarItem, {
      desktop: isDesktop
    }, /*#__PURE__*/React__default.createElement(StyledSupplementaryBarItemIcon, null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faPhone
    })), /*#__PURE__*/React__default.createElement(StyledSupplementaryBarItemText, null, /*#__PURE__*/React__default.createElement(Typography, {
      component: "span",
      variant: "subtitle2"
    }, "Request a call"))), showChatOnline && /*#__PURE__*/React__default.createElement(StyledSupplementaryBarItem, {
      desktop: isDesktop
    }, /*#__PURE__*/React__default.createElement(StyledSupplementaryBarItemIcon, null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      color: "",
      icon: faComments
    })), /*#__PURE__*/React__default.createElement(StyledSupplementaryBarItemText, null, /*#__PURE__*/React__default.createElement(Typography, {
      component: "span",
      variant: "subtitle2"
    }, "Chat online"))), showCallUs && /*#__PURE__*/React__default.createElement(SeparatorContainer, null, /*#__PURE__*/React__default.createElement(Separator, {
      noSpacing: true,
      type: "vertical"
    })), phoneNumber && /*#__PURE__*/React__default.createElement(StyledFlexContainer, null, /*#__PURE__*/React__default.createElement(StyledSupplementaryBarItemText, null, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body1"
    }, "Call us on")), /*#__PURE__*/React__default.createElement(StyledSupplementaryBarItem, {
      desktop: isDesktop
    }, /*#__PURE__*/React__default.createElement(StyledSupplementaryBarItemIcon, null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faPhone
    })), /*#__PURE__*/React__default.createElement(StyledSupplementaryBarItemText, null, /*#__PURE__*/React__default.createElement(StyledLink, {
      href: "tel:".concat(phoneNumber),
      target: "link-target"
    }, /*#__PURE__*/React__default.createElement(Typography, {
      component: "span",
      variant: "subtitle2"
    }, phoneNumber))))))))));
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, overlay && /*#__PURE__*/React__default.createElement(Overlay, {
    visible: visible,
    opacityLevel: overlayOpacity,
    handleClick: handleOverlayClick,
    zIndex: zIndex
  }), visible && /*#__PURE__*/React__default.createElement(ReactRemoveScroll, {
    enabled: !disableBodyScrollLock
  }, /*#__PURE__*/React__default.createElement(Wrapper, {
    trapFocus: trapFocus,
    focusTrapOptions: focusTrapOptions
  }, /*#__PURE__*/React__default.createElement(StyledAlignment, {
    visible: visible,
    zIndex: zIndex
  }, /*#__PURE__*/React__default.createElement(StyledModal, {
    id: id,
    className: classNames,
    desktop: isDesktop,
    dynamicHeight: dynamicHeight
  }, Header(), /*#__PURE__*/React__default.createElement(StyledContent, {
    desktop: isDesktop,
    modalHeaderBarHeight: headerBarHeight,
    showSupplementaryBar: showSupplementaryBar
  }, /*#__PURE__*/React__default.createElement(StyledContentChildren, {
    desktop: isDesktop,
    supplementaryBarHeight: supplementaryBarHeight,
    showSupplementaryBar: showSupplementaryBar
  }, children), ActionButtons(), SupplementaryBar()))))));
};

Modal.propTypes = {
  /**
   * A descriptive label used in tracking user interactions with this component
   */
  trackingLabel: PropTypes__default.string.isRequired,

  /**
   * Unique identifier for the modal
   */
  id: PropTypes__default.string,

  /**
   * Bool for modal opening/closing. Handled via state in the parent component
   */
  visible: PropTypes__default.bool,

  /**
   * Method for closing the modal. Handled via state in the parent component. Pass to an overlay (if included) to
   * close the modal on click of the overlay
   */
  handleClose: PropTypes__default.func,

  /**
   * To specify whether the modal should scale its height according to content size
   */
  dynamicHeight: PropTypes__default.bool,

  /**
   * Extend styles with additional classNames
   */
  className: PropTypes__default.string,

  /**
   * Render an overlay over the remainder of the screen (blocking interaction)
   */
  overlay: PropTypes__default.bool,

  /**
   * Defines the opacity of the overlay, if rendered. (0 to 1)
   */
  overlayOpacity: PropTypes__default.number,

  /**
   * Called when the overlay is clicked
   */
  handleOverlayClick: PropTypes__default.func,

  /**
   * Title for the primary action button
   */
  primaryActionTitle: PropTypes__default.string,

  /**
   * Called when the primary action is clicked
   */
  handlePrimaryActionClick: PropTypes__default.func,

  /**
   * Title for the secondary action button
   */
  secondaryActionTitle: PropTypes__default.string,

  /**
   * Called when the secondary action is clicked
   */
  handleSecondaryActionClick: PropTypes__default.func,

  /**
   * The child content of the Modal
   */
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node, PropTypes__default.arrayOf(PropTypes__default.node)]),

  /**
   * The title text
   */
  title: PropTypes__default.node,

  /**
   * The icon to display next to the title
   */
  titleIcon: PropTypes__default.node,

  /**
   * zIndex for the modal & overlay (if using)
   */
  zIndex: PropTypes__default.number,

  /**
   * show the contact box below the modal content
   */
  showSupplementaryBar: PropTypes__default.bool,

  /**
   * The supplementary bar options to show
   */
  supplementaryBarOptions: PropTypes__default.shape({
    showRequestCall: PropTypes__default.bool,
    showChatOnline: PropTypes__default.bool,
    phoneNumber: PropTypes__default.string
  }),

  /**
   * Traps focus within the modal
   */
  trapFocus: PropTypes__default.bool,

  /**
   * Options to be passed to the focus-trap library
   * Common use case: By default the library deactivates the trap when the Escape key is pressed, for our
   * use case we likely want to disable that with focusTrapOptions: { escapeDeactivates: false }
   * https://github.com/focus-trap/focus-trap#focustrap--createfocustrapelement-createoptions
   */
  focusTrapOptions: PropTypes__default.object,

  /**
   * Disable the body scroll lock behavior
   */
  disableBodyScrollLock: PropTypes__default.bool
};
Modal.defaultProps = {
  id: null,
  visible: false,
  dynamicHeight: false,
  handleClose: null,
  className: '',
  children: '',
  overlay: false,
  overlayOpacity: 0.7,
  handleOverlayClick: null,
  primaryActionTitle: null,
  handlePrimaryActionClick: null,
  secondaryActionTitle: null,
  handleSecondaryActionClick: null,
  titleIcon: null,
  title: '',
  zIndex: 999999,
  showSupplementaryBar: false,
  supplementaryBarOptions: {
    showRequestCall: true,
    showChatOnline: true,
    phoneNumber: ''
  },
  trapFocus: false,
  focusTrapOptions: {},
  disableBodyScrollLock: false
};

var _templateObject$d, _templateObject2$5, _templateObject3$5, _templateObject4$2, _templateObject5$2;
var StyledAlignment$1 = styled__default.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  right: 0;\n  pointer-events: none;\n  z-index: ", ";\n"])), function (_ref) {
  var zIndex = _ref.zIndex;
  return zIndex;
});
var animateIn$1 = styled.keyframes(["from{transform:translateY(-20%);opacity:0;}to{transform:translateY(0);opacity:1;}"]);
var StyledModal$1 = styled__default.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  box-shadow: ", ";\n  z-index: inherit;\n  max-width: ", ";\n  min-width: 32.5rem;\n  ", ";\n  pointer-events: auto;\n  position: relative;\n  animation-name: ", ";\n  animation-duration: 0.3s;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grey100;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.boxShadow.lg;
}, function (_ref4) {
  var breakpoint = _ref4.breakpoint;
  return breakpoint === 'sm' ? '57.6rem' : '76.8rem';
}, function (_ref5) {
  var dynamicHeight = _ref5.dynamicHeight;
  return !dynamicHeight && styled.css(["height:100%;max-height:", ";"], function (_ref6) {
    var desktop = _ref6.desktop,
        breakpoint = _ref6.breakpoint;
    return (desktop || breakpoint === 'sm') && '69.6rem';
  });
}, animateIn$1);
var StyledHeader = styled__default.div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  padding: ", ";\n"])), function (_ref7) {
  var desktop = _ref7.desktop;
  return desktop ? 'flex-end' : 'flex-start';
}, function (_ref8) {
  var desktop = _ref8.desktop;
  return desktop ? '2.4rem 2.4rem 2rem 2.4rem' : '3rem 2.4rem 1.45rem 2.4rem';
});
var StyledCloseIcon$1 = styled__default.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  z-index: inherit;\n  color: ", ";\n  font-size: ", ";\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.grey600;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSize['3xl'];
});
var StyledCloseButton = styled__default.div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;    \n"])));

var WizardModal = function WizardModal(_ref) {
  var trackingLabel = _ref.trackingLabel,
      propsId = _ref.id,
      dynamicHeight = _ref.dynamicHeight,
      visible = _ref.visible,
      onClose = _ref.onClose,
      className = _ref.className,
      overlay = _ref.overlay,
      overlayOpacity = _ref.overlayOpacity,
      zIndex = _ref.zIndex,
      children = _ref.children,
      goBackActionTitle = _ref.goBackActionTitle,
      disableBodyScrollLock = _ref.disableBodyScrollLock;
  var id = useId(propsId);
  var headerBarRef = React.useRef(null);
  var wizardModalRef = React.useRef(null);

  var _useState = React.useState(),
      _useState2 = _slicedToArray(_useState, 2),
      headerBarHeight = _useState2[0],
      setHeaderBarHeight = _useState2[1];

  var _useContext = React.useContext(manorProvider.ManorContext),
      isDesktop = _useContext.isDesktop,
      breakpoint = _useContext.breakpoint,
      trackInteraction = _useContext.trackInteraction;

  var classNames = "\n    ".concat(className, "\n  ");
  React.useLayoutEffect(function () {
    if (headerBarRef) {
      var handleHeaderBarResize = function handleHeaderBarResize() {
        if (headerBarRef.current) {
          setHeaderBarHeight(headerBarRef.current.offsetHeight);
        }
      };

      var throttledHeaderBarResize = throttle(handleHeaderBarResize, 25);
      window.addEventListener('resize', throttledHeaderBarResize);
      return function () {
        window.removeEventListener('resize', throttledHeaderBarResize);
      };
    }

    return null;
  }, [headerBarRef, headerBarHeight]);
  React.useEffect(function () {
    if (headerBarRef && headerBarRef.current) {
      setHeaderBarHeight(headerBarRef.current.offsetHeight);
    }
  }, [visible]);

  var closeClickHandler = function closeClickHandler() {
    if (onClose) onClose();
    trackInteraction('Click', 'Button', 'Other', trackingLabel, 'Close');
  };

  var overlayClickHandler = function overlayClickHandler() {
    if (onClose) onClose();
    trackInteraction('Click', 'Overlay', 'Other', trackingLabel, 'Close');
  };

  var Header = function Header() {
    // TODO: this is not using standard manor components, need to refactor this to do so. See also: Modal.conponent.js
    var DesktopHeader = function DesktopHeader() {
      return /*#__PURE__*/React__default.createElement(StyledCloseIcon$1, {
        className: "icon-close",
        onClick: closeClickHandler,
        onKeyPress: closeClickHandler,
        "aria-label": "Close Modal",
        tabIndex: "0",
        role: "button",
        "aria-pressed": "false"
      }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
        icon: faTimes
      }));
    };

    var MobileHeader = function MobileHeader() {
      return /*#__PURE__*/React__default.createElement(StyledCloseButton, null, /*#__PURE__*/React__default.createElement(Button, {
        id: "back-btn",
        variant: "tertiary",
        handleClick: onClose,
        icon: faArrowLeft,
        trackingLabel: "Back button for ".concat(trackingLabel),
        style: {
          padding: 'inherit',
          margin: 'inherit'
        }
      }, goBackActionTitle));
    };

    return /*#__PURE__*/React__default.createElement(StyledHeader, {
      ref: headerBarRef,
      desktop: isDesktop
    }, isDesktop ? /*#__PURE__*/React__default.createElement(DesktopHeader, null) : /*#__PURE__*/React__default.createElement(MobileHeader, null));
  };

  return visible && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, overlay && /*#__PURE__*/React__default.createElement(Overlay, {
    visible: visible,
    opacityLevel: overlayOpacity,
    handleClick: overlayClickHandler,
    zIndex: zIndex
  }), /*#__PURE__*/React__default.createElement(ReactRemoveScroll, {
    enabled: !disableBodyScrollLock
  }, /*#__PURE__*/React__default.createElement(StyledAlignment$1, {
    visible: visible,
    zIndex: zIndex,
    ref: wizardModalRef
  }, /*#__PURE__*/React__default.createElement(StyledModal$1, {
    id: id,
    className: classNames,
    desktop: isDesktop,
    dynamicHeight: dynamicHeight,
    breakpoint: breakpoint
  }, /*#__PURE__*/React__default.createElement(Header, null), children))));
};

WizardModal.propTypes = {
  /**
   * A descriptive label used in tracking user interactions with this component
   */
  trackingLabel: PropTypes__default.string.isRequired,

  /**
   * Unique identifier for the modal
   */
  id: PropTypes__default.string,

  /**
   * Bool for modal opening/closing. Handled via state in the parent component
   */
  visible: PropTypes__default.bool,

  /**
   * Method for closing the modal. Handled via state in the parent component. Pass to an overlay (if included) to
   * close the modal on click of the overlay
   */
  onClose: PropTypes__default.func,

  /**
   * To specify whether the modal should scale its height according to content size
   */
  dynamicHeight: PropTypes__default.bool,

  /**
   * Extend styles with additional classNames
   */
  className: PropTypes__default.string,

  /**
   * Render an overlay over the remainder of the screen (blocking interaction)
   */
  overlay: PropTypes__default.bool,

  /**
   * Defines the opacity of the overlay, if rendered. (0 to 1)
   */
  overlayOpacity: PropTypes__default.number,

  /**
   * zIndex for the modal & overlay (if using)
   */
  zIndex: PropTypes__default.number,

  /**
   * The content of the modal
   */
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node, PropTypes__default.arrayOf(PropTypes__default.node)]),

  /**
   * Title for the go back action button
   */
  goBackActionTitle: PropTypes__default.string,

  /**
   * Disable the scroll lock behavior
   */
  disableBodyScrollLock: PropTypes__default.bool
};
WizardModal.defaultProps = {
  id: null,
  visible: false,
  dynamicHeight: false,
  onClose: null,
  className: '',
  overlay: true,
  overlayOpacity: 0.7,
  zIndex: 999999,
  children: null,
  goBackActionTitle: 'Back to results',
  disableBodyScrollLock: false
};

var _templateObject$e, _templateObject2$6;
var StyledAlignment$2 = styled__default.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  right: 0;\n  pointer-events: none;\n  z-index: ", ";\n"])), function (_ref) {
  var zIndex = _ref.zIndex;
  return zIndex;
});
var animateIn$2 = styled.keyframes(["from{transform:translateY(-20%);opacity:0;}to{transform:translateY(0);opacity:1;}"]);
var StyledModal$2 = styled__default.div(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n  background: ", ";\n  box-shadow: ", ";\n  z-index: inherit;\n  pointer-events: auto;\n  position: relative;\n  animation-name: ", ";\n  animation-duration: .3s;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.boxShadow.lg;
}, animateIn$2);

var Wrapper$1 = function Wrapper(_ref) {
  var trapFocus = _ref.trapFocus,
      focusTrapOptions = _ref.focusTrapOptions,
      children = _ref.children;

  if (trapFocus) {
    return /*#__PURE__*/React__default.createElement(focusTrapReact, {
      focusTrapOptions: focusTrapOptions
    }, children);
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
};

var GenericModal = function GenericModal(_ref2) {
  var propsId = _ref2.id,
      visible = _ref2.visible,
      className = _ref2.className,
      children = _ref2.children,
      overlay = _ref2.overlay,
      overlayOpacity = _ref2.overlayOpacity,
      handleOverlayClick = _ref2.handleOverlayClick,
      zIndex = _ref2.zIndex,
      trapFocus = _ref2.trapFocus,
      focusTrapOptions = _ref2.focusTrapOptions,
      disableBodyScrollLock = _ref2.disableBodyScrollLock;
  var id = useId(propsId);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, overlay && /*#__PURE__*/React__default.createElement(Overlay, {
    visible: visible,
    opacityLevel: overlayOpacity,
    handleClick: handleOverlayClick,
    zIndex: zIndex
  }), visible && /*#__PURE__*/React__default.createElement(ReactRemoveScroll, {
    enabled: !disableBodyScrollLock
  }, /*#__PURE__*/React__default.createElement(Wrapper$1, {
    trapFocus: trapFocus,
    focusTrapOptions: focusTrapOptions
  }, /*#__PURE__*/React__default.createElement(StyledAlignment$2, {
    visible: visible,
    zIndex: zIndex
  }, /*#__PURE__*/React__default.createElement(StyledModal$2, {
    id: id,
    className: className
  }, children)))));
};

GenericModal.propTypes = {
  /**
   * Unique identifier for the modal
   */
  id: PropTypes__default.string,

  /**
   * Bool for modal opening/closing. Handled via state in the parent component
   */
  visible: PropTypes__default.bool,

  /**
   * Extend styles with additional classNames
   */
  className: PropTypes__default.string,

  /**
   * Render an overlay over the remainder of the screen (blocking interaction)
   */
  overlay: PropTypes__default.bool,

  /**
   * Defines the opacity of the overlay, if rendered. (0 to 1)
   */
  overlayOpacity: PropTypes__default.number,

  /**
   * Called when the overlay is clicked
   */
  handleOverlayClick: PropTypes__default.func,

  /**
   * The child content of the Modal
   */
  children: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node, PropTypes__default.arrayOf(PropTypes__default.node)]),

  /**
   * zIndex for the modal & overlay (if using)
   */
  zIndex: PropTypes__default.number,

  /**
   * Traps focus within the modal
   */
  trapFocus: PropTypes__default.bool,

  /**
   * Options to be passed to the focus-trap library
   * Common use case: By default the library deactivates the trap when the Escape key is pressed, for our
   * use case we likely want to disable that with focusTrapOptions: { escapeDeactivates: false }
   * https://github.com/focus-trap/focus-trap#focustrap--createfocustrapelement-createoptions
   */
  // eslint-disable-next-line react/forbid-prop-types
  focusTrapOptions: PropTypes__default.object,

  /**
   * Disable the scroll lock behavior
  */
  disableBodyScrollLock: PropTypes__default.bool
};
GenericModal.defaultProps = {
  id: null,
  visible: false,
  className: '',
  children: '',
  overlay: false,
  overlayOpacity: 0.7,
  handleOverlayClick: null,
  zIndex: 999999,
  trapFocus: false,
  focusTrapOptions: {},
  disableBodyScrollLock: false
};

exports.GenericModal = GenericModal;
exports.Modal = Modal;
exports.WizardModal = WizardModal;
